var map = {
	"./404/404": [
		89604,
		9,
		20115,
		89604
	],
	"./404/404.js": [
		89604,
		9,
		20115,
		89604
	],
	"./a-page-template/a-page-template": [
		22200,
		9,
		68039,
		20115,
		89604,
		49374,
		92231,
		22200
	],
	"./a-page-template/a-page-template.js": [
		22200,
		9,
		68039,
		20115,
		89604,
		49374,
		92231,
		22200
	],
	"./a-page-template/a-page-template.scss": [
		92231,
		9,
		92231
	],
	"./about/about": [
		73466,
		9,
		80570,
		34670,
		68039,
		20115,
		89604,
		49374,
		84230,
		68449,
		73466
	],
	"./about/about.js": [
		73466,
		9,
		80570,
		34670,
		68039,
		20115,
		89604,
		49374,
		84230,
		68449,
		73466
	],
	"./about/about.scss": [
		68449,
		9,
		68449
	],
	"./adopters/adopters": [
		88852,
		9,
		68039,
		90521,
		88852
	],
	"./adopters/adopters.js": [
		88852,
		9,
		68039,
		90521,
		88852
	],
	"./adopters/adopters.scss": [
		90521,
		9,
		90521
	],
	"./adoption/adoption": [
		9637,
		9,
		15104,
		34670,
		68039,
		63028,
		20115,
		89604,
		49374,
		80370,
		20952,
		4204,
		98677,
		67953,
		89465,
		30703,
		63667,
		29424,
		56134,
		98098,
		442,
		40175,
		90928,
		74095,
		9637
	],
	"./adoption/adoption.js": [
		9637,
		9,
		15104,
		34670,
		68039,
		63028,
		20115,
		89604,
		49374,
		80370,
		20952,
		4204,
		98677,
		67953,
		89465,
		30703,
		63667,
		29424,
		56134,
		98098,
		442,
		40175,
		90928,
		74095,
		9637
	],
	"./adoption/adoption.scss": [
		74095,
		9,
		74095
	],
	"./adoption/how-using/how-using": [
		90928,
		9,
		63028,
		80370,
		4204,
		98677,
		67953,
		89465,
		30703,
		40175,
		90928
	],
	"./adoption/how-using/how-using.js": [
		90928,
		9,
		63028,
		80370,
		4204,
		98677,
		67953,
		89465,
		30703,
		40175,
		90928
	],
	"./adoption/how-using/how-using.scss": [
		40175,
		9,
		40175
	],
	"./ally-logos/ally-logos": [
		27793,
		9,
		15104,
		34670,
		68039,
		20115,
		89604,
		49374,
		68968,
		27793
	],
	"./ally-logos/ally-logos.js": [
		27793,
		9,
		15104,
		34670,
		68039,
		20115,
		89604,
		49374,
		68968,
		27793
	],
	"./ally-logos/ally-logos.scss": [
		68968,
		9,
		68968
	],
	"./assignable/assignable": [
		76052,
		9,
		15104,
		87850,
		80570,
		34670,
		68039,
		20115,
		50566,
		89604,
		49374,
		84230,
		96038,
		3115,
		69994,
		78120,
		17657,
		88491,
		72615,
		82151,
		35773,
		53564,
		51445,
		33782,
		61931,
		62730,
		22714,
		19065,
		76052
	],
	"./assignable/assignable.js": [
		76052,
		9,
		15104,
		87850,
		80570,
		34670,
		68039,
		20115,
		50566,
		89604,
		49374,
		84230,
		96038,
		3115,
		69994,
		78120,
		17657,
		88491,
		72615,
		82151,
		35773,
		53564,
		51445,
		33782,
		61931,
		62730,
		22714,
		19065,
		76052
	],
	"./assignable/assignable.scss": [
		53564,
		9,
		53564
	],
	"./assignable/sections/about/about": [
		61931,
		9,
		15104,
		34670,
		50566,
		3115,
		82151,
		61931
	],
	"./assignable/sections/about/about.js": [
		61931,
		9,
		15104,
		34670,
		50566,
		3115,
		82151,
		61931
	],
	"./assignable/sections/about/about.scss": [
		82151,
		9,
		82151
	],
	"./assignable/sections/banner/banner": [
		51445,
		9,
		34670,
		84230,
		88491,
		51445
	],
	"./assignable/sections/banner/banner.js": [
		51445,
		9,
		34670,
		84230,
		88491,
		51445
	],
	"./assignable/sections/banner/banner.scss": [
		88491,
		9,
		88491
	],
	"./assignable/sections/courses/courses": [
		33782,
		9,
		17657,
		33782
	],
	"./assignable/sections/courses/courses.js": [
		33782,
		9,
		17657,
		33782
	],
	"./assignable/sections/courses/courses.scss": [
		17657,
		9,
		17657
	],
	"./assignable/sections/cta/cta": [
		22714,
		9,
		35773,
		22714
	],
	"./assignable/sections/cta/cta.js": [
		22714,
		9,
		35773,
		22714
	],
	"./assignable/sections/cta/cta.scss": [
		35773,
		9,
		35773
	],
	"./assignable/sections/faq/faq": [
		19065,
		9,
		15104,
		87850,
		34670,
		96038,
		69994,
		72615,
		19065
	],
	"./assignable/sections/faq/faq.js": [
		19065,
		9,
		15104,
		87850,
		34670,
		96038,
		69994,
		72615,
		19065
	],
	"./assignable/sections/faq/faq.scss": [
		72615,
		9,
		72615
	],
	"./assignable/sections/overlapping-quote/overlapping-quote": [
		62730,
		9,
		78120,
		62730
	],
	"./assignable/sections/overlapping-quote/overlapping-quote.js": [
		62730,
		9,
		78120,
		62730
	],
	"./assignable/sections/overlapping-quote/overlapping-quote.scss": [
		78120,
		9,
		78120
	],
	"./blog/article-summary/article-summary": [
		97915,
		9,
		34670,
		33948,
		97915
	],
	"./blog/article-summary/article-summary.js": [
		97915,
		9,
		34670,
		33948,
		97915
	],
	"./blog/article-summary/article-summary.scss": [
		43197,
		9,
		43197
	],
	"./blog/article/article": [
		67775,
		9,
		15104,
		34670,
		68039,
		20115,
		50566,
		33948,
		80550,
		6771,
		7691,
		67775
	],
	"./blog/article/article.js": [
		67775,
		9,
		15104,
		34670,
		68039,
		20115,
		50566,
		33948,
		80550,
		6771,
		7691,
		67775
	],
	"./blog/article/article.scss": [
		80550,
		9,
		80550
	],
	"./blog/article/use-progress": [
		7691,
		9,
		50566,
		7691
	],
	"./blog/article/use-progress.js": [
		7691,
		9,
		50566,
		7691
	],
	"./blog/blog": [
		63966,
		9,
		15104,
		67913,
		34670,
		68039,
		63028,
		20115,
		50295,
		50566,
		33948,
		89604,
		49374,
		80370,
		4204,
		98677,
		67953,
		89465,
		44016,
		8011,
		85453,
		30703,
		63667,
		29424,
		54088,
		41076,
		97915,
		80550,
		98098,
		58569,
		6771,
		63966
	],
	"./blog/blog-context": [
		41076,
		9,
		68039,
		41076
	],
	"./blog/blog-context.js": [
		41076,
		9,
		68039,
		41076
	],
	"./blog/blog.js": [
		63966,
		9,
		15104,
		67913,
		34670,
		68039,
		63028,
		20115,
		50295,
		50566,
		33948,
		89604,
		49374,
		80370,
		4204,
		98677,
		67953,
		89465,
		44016,
		8011,
		85453,
		30703,
		63667,
		29424,
		54088,
		41076,
		97915,
		80550,
		98098,
		58569,
		6771,
		63966
	],
	"./blog/blog.scss": [
		69545,
		9,
		69545
	],
	"./blog/disqus-form/disqus-form": [
		25847,
		9,
		25847
	],
	"./blog/disqus-form/disqus-form.js": [
		25847,
		9,
		25847
	],
	"./blog/explore-page/explore-page": [
		26573,
		9,
		15104,
		34670,
		68039,
		20115,
		50566,
		33948,
		44016,
		85453,
		54088,
		41076,
		97915,
		58569,
		4488,
		43913,
		70335,
		26573
	],
	"./blog/explore-page/explore-page.js": [
		26573,
		9,
		15104,
		34670,
		68039,
		20115,
		50566,
		33948,
		44016,
		85453,
		54088,
		41076,
		97915,
		58569,
		4488,
		43913,
		70335,
		26573
	],
	"./blog/gated-content-dialog/gated-content-dialog": [
		32931,
		9,
		34670,
		68039,
		63028,
		20115,
		50295,
		89604,
		49374,
		80370,
		4204,
		98677,
		67953,
		89465,
		30703,
		63667,
		98098,
		3833,
		32931
	],
	"./blog/gated-content-dialog/gated-content-dialog.js": [
		32931,
		9,
		34670,
		68039,
		63028,
		20115,
		50295,
		89604,
		49374,
		80370,
		4204,
		98677,
		67953,
		89465,
		30703,
		63667,
		98098,
		3833,
		32931
	],
	"./blog/gated-content-dialog/gated-content-dialog.scss": [
		3833,
		9,
		3833
	],
	"./blog/latest-blog-posts/latest-blog-posts": [
		49079,
		9,
		15104,
		67913,
		34670,
		68039,
		33948,
		44016,
		8011,
		85453,
		54088,
		41076,
		97915,
		58569,
		43913,
		5283,
		49079
	],
	"./blog/latest-blog-posts/latest-blog-posts.js": [
		49079,
		9,
		15104,
		67913,
		34670,
		68039,
		33948,
		44016,
		8011,
		85453,
		54088,
		41076,
		97915,
		58569,
		43913,
		5283,
		49079
	],
	"./blog/latest-blog-posts/latest-blog-posts.scss": [
		5283,
		9,
		5283
	],
	"./blog/more-stories/more-stories": [
		43913,
		9,
		34670,
		68039,
		33948,
		54088,
		41076,
		97915,
		58569,
		43913
	],
	"./blog/more-stories/more-stories.js": [
		43913,
		9,
		34670,
		68039,
		33948,
		54088,
		41076,
		97915,
		58569,
		43913
	],
	"./blog/more-stories/more-stories.scss": [
		58569,
		9,
		58569
	],
	"./blog/pinned-article/pinned-article": [
		70335,
		9,
		34670,
		68039,
		33948,
		54088,
		41076,
		97915,
		4488,
		70335
	],
	"./blog/pinned-article/pinned-article.js": [
		70335,
		9,
		34670,
		68039,
		33948,
		54088,
		41076,
		97915,
		4488,
		70335
	],
	"./blog/pinned-article/pinned-article.scss": [
		4488,
		9,
		4488
	],
	"./blog/search-results/no-results": [
		9806,
		7,
		34670,
		68039,
		33948,
		54088,
		41076,
		97915,
		58569,
		4488,
		43913,
		70335,
		89953,
		9806
	],
	"./blog/search-results/no-results.scss": [
		89953,
		9,
		89953
	],
	"./blog/search-results/no-results.tsx": [
		9806,
		7,
		34670,
		68039,
		33948,
		54088,
		41076,
		97915,
		58569,
		4488,
		43913,
		70335,
		89953,
		9806
	],
	"./blog/search-results/search-results": [
		38418,
		9,
		67913,
		34670,
		68039,
		33948,
		29424,
		54088,
		41076,
		97915,
		58569,
		4488,
		43913,
		70335,
		89953,
		19397,
		9806,
		38418
	],
	"./blog/search-results/search-results.js": [
		38418,
		9,
		67913,
		34670,
		68039,
		33948,
		29424,
		54088,
		41076,
		97915,
		58569,
		4488,
		43913,
		70335,
		89953,
		19397,
		9806,
		38418
	],
	"./blog/search-results/search-results.scss": [
		19397,
		9,
		19397
	],
	"./bookstore-suppliers/bookstore-suppliers": [
		84628,
		9,
		15104,
		34670,
		68039,
		20115,
		89604,
		49374,
		95689,
		84628
	],
	"./bookstore-suppliers/bookstore-suppliers.js": [
		84628,
		9,
		15104,
		34670,
		68039,
		20115,
		89604,
		49374,
		95689,
		84628
	],
	"./bookstore-suppliers/bookstore-suppliers.scss": [
		95689,
		9,
		95689
	],
	"./campaign/campaign": [
		77709,
		9,
		77709
	],
	"./campaign/campaign.js": [
		77709,
		9,
		77709
	],
	"./confirmation/confirmation": [
		42745,
		9,
		34670,
		68039,
		20115,
		89604,
		49374,
		12790,
		95303,
		93450,
		67600,
		14763,
		40436,
		54187,
		53575,
		42745
	],
	"./confirmation/confirmation.js": [
		42745,
		9,
		34670,
		68039,
		20115,
		89604,
		49374,
		12790,
		95303,
		93450,
		67600,
		14763,
		40436,
		54187,
		53575,
		42745
	],
	"./confirmation/confirmation.scss": [
		54187,
		9,
		54187
	],
	"./contact/contact": [
		19308,
		9,
		34670,
		68039,
		63028,
		80370,
		4204,
		98677,
		19561,
		19295,
		19308
	],
	"./contact/contact.js": [
		19308,
		9,
		34670,
		68039,
		63028,
		80370,
		4204,
		98677,
		19561,
		19295,
		19308
	],
	"./contact/contact.scss": [
		19295,
		9,
		19295
	],
	"./contact/form": [
		19561,
		9,
		63028,
		80370,
		4204,
		98677,
		19561
	],
	"./contact/form.js": [
		19561,
		9,
		63028,
		80370,
		4204,
		98677,
		19561
	],
	"./details/common/authors": [
		71057,
		9,
		67913,
		71057
	],
	"./details/common/authors.js": [
		71057,
		9,
		67913,
		71057
	],
	"./details/common/common": [
		65026,
		9,
		15104,
		67913,
		34670,
		71787,
		63777,
		61954,
		9009,
		71057,
		65026
	],
	"./details/common/common.js": [
		65026,
		9,
		15104,
		67913,
		34670,
		71787,
		63777,
		61954,
		9009,
		71057,
		65026
	],
	"./details/common/errata": [
		9009,
		9,
		34670,
		9009
	],
	"./details/common/errata.js": [
		9009,
		9,
		34670,
		9009
	],
	"./details/common/featured-resources/featured-resources": [
		96900,
		9,
		15104,
		33441,
		25783,
		34670,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		14437,
		45580,
		39247,
		68771,
		94653,
		73110,
		96900
	],
	"./details/common/featured-resources/featured-resources.js": [
		96900,
		9,
		15104,
		33441,
		25783,
		34670,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		14437,
		45580,
		39247,
		68771,
		94653,
		73110,
		96900
	],
	"./details/common/featured-resources/featured-resources.scss": [
		73110,
		9,
		73110
	],
	"./details/common/get-this-title": [
		89895,
		9,
		15104,
		33441,
		25783,
		34670,
		63028,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		40172,
		24536,
		5719,
		95301,
		28521,
		85197,
		53246,
		6234,
		97907,
		89895
	],
	"./details/common/get-this-title-files/amazon-associates-link": [
		53246,
		7,
		53246
	],
	"./details/common/get-this-title-files/amazon-associates-link.tsx": [
		53246,
		7,
		53246
	],
	"./details/common/get-this-title-files/get-this-title.scss": [
		97907,
		9,
		97907
	],
	"./details/common/get-this-title-files/give-before-pdf/common-elements": [
		54873,
		7,
		15104,
		33441,
		25783,
		27752,
		54873
	],
	"./details/common/get-this-title-files/give-before-pdf/common-elements.tsx": [
		54873,
		7,
		15104,
		33441,
		25783,
		27752,
		54873
	],
	"./details/common/get-this-title-files/give-before-pdf/give-before-online": [
		76536,
		7,
		15104,
		33441,
		25783,
		42673,
		27752,
		37827,
		54873,
		76536
	],
	"./details/common/get-this-title-files/give-before-pdf/give-before-online.tsx": [
		76536,
		7,
		15104,
		33441,
		25783,
		42673,
		27752,
		37827,
		54873,
		76536
	],
	"./details/common/get-this-title-files/give-before-pdf/give-before-pdf": [
		28365,
		7,
		15104,
		33441,
		25783,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365
	],
	"./details/common/get-this-title-files/give-before-pdf/give-before-pdf.scss": [
		20109,
		9,
		20109
	],
	"./details/common/get-this-title-files/give-before-pdf/give-before-pdf.tsx": [
		28365,
		7,
		15104,
		33441,
		25783,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365
	],
	"./details/common/get-this-title-files/give-before-pdf/thank-you-form": [
		37827,
		9,
		42673,
		37827
	],
	"./details/common/get-this-title-files/give-before-pdf/thank-you-form.js": [
		37827,
		9,
		42673,
		37827
	],
	"./details/common/get-this-title-files/give-before-pdf/thank-you-form.scss": [
		42673,
		9,
		42673
	],
	"./details/common/get-this-title-files/give-before-pdf/use-donation-popup-data": [
		81321,
		7,
		81321
	],
	"./details/common/get-this-title-files/give-before-pdf/use-donation-popup-data.ts": [
		81321,
		7,
		81321
	],
	"./details/common/get-this-title-files/give-before-pdf/use-give-dialog": [
		61958,
		7,
		15104,
		33441,
		25783,
		34670,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958
	],
	"./details/common/get-this-title-files/give-before-pdf/use-give-dialog.tsx": [
		61958,
		7,
		15104,
		33441,
		25783,
		34670,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958
	],
	"./details/common/get-this-title-files/give-before-pdf/use-give-links": [
		27752,
		7,
		27752
	],
	"./details/common/get-this-title-files/give-before-pdf/use-give-links.ts": [
		27752,
		7,
		27752
	],
	"./details/common/get-this-title-files/options": [
		6234,
		9,
		15104,
		33441,
		25783,
		34670,
		63028,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		40172,
		24536,
		5719,
		95301,
		28521,
		85197,
		53246,
		6234
	],
	"./details/common/get-this-title-files/options.js": [
		6234,
		9,
		15104,
		33441,
		25783,
		34670,
		63028,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		40172,
		24536,
		5719,
		95301,
		28521,
		85197,
		53246,
		6234
	],
	"./details/common/get-this-title-files/order-print-copy/order-print-copy": [
		95301,
		9,
		15104,
		34670,
		40172,
		95301
	],
	"./details/common/get-this-title-files/order-print-copy/order-print-copy.js": [
		95301,
		9,
		15104,
		34670,
		40172,
		95301
	],
	"./details/common/get-this-title-files/order-print-copy/order-print-copy.scss": [
		40172,
		9,
		40172
	],
	"./details/common/get-this-title-files/recommended-callout/recommended-callout": [
		85197,
		9,
		15104,
		34670,
		24536,
		85197
	],
	"./details/common/get-this-title-files/recommended-callout/recommended-callout.js": [
		85197,
		9,
		15104,
		34670,
		24536,
		85197
	],
	"./details/common/get-this-title-files/recommended-callout/recommended-callout.scss": [
		24536,
		9,
		24536
	],
	"./details/common/get-this-title-files/recommended-callout/use-callout-counter": [
		28521,
		9,
		28521
	],
	"./details/common/get-this-title-files/recommended-callout/use-callout-counter.js": [
		28521,
		9,
		28521
	],
	"./details/common/get-this-title.js": [
		89895,
		9,
		15104,
		33441,
		25783,
		34670,
		63028,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		40172,
		24536,
		5719,
		95301,
		28521,
		85197,
		53246,
		6234,
		97907,
		89895
	],
	"./details/common/hooks": [
		64343,
		9,
		67913,
		71787,
		58662,
		64343
	],
	"./details/common/hooks.js": [
		64343,
		9,
		67913,
		71787,
		58662,
		64343
	],
	"./details/common/let-us-know/let-us-know": [
		64330,
		9,
		15104,
		34670,
		7270,
		64330
	],
	"./details/common/let-us-know/let-us-know.js": [
		64330,
		9,
		15104,
		34670,
		7270,
		64330
	],
	"./details/common/let-us-know/let-us-know.scss": [
		7270,
		9,
		7270
	],
	"./details/common/links-to-translations": [
		94873,
		7,
		15104,
		45580,
		59313,
		94873
	],
	"./details/common/links-to-translations.tsx": [
		94873,
		7,
		15104,
		45580,
		59313,
		94873
	],
	"./details/common/publication-info": [
		61954,
		9,
		67913,
		34670,
		71787,
		61954
	],
	"./details/common/publication-info.js": [
		61954,
		9,
		67913,
		34670,
		71787,
		61954
	],
	"./details/common/resource-box/left-content": [
		14437,
		7,
		15104,
		33441,
		25783,
		34670,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		14437
	],
	"./details/common/resource-box/left-content.tsx": [
		14437,
		7,
		15104,
		33441,
		25783,
		34670,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		14437
	],
	"./details/common/resource-box/resource-box": [
		39247,
		9,
		15104,
		33441,
		25783,
		34670,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		14437,
		39247
	],
	"./details/common/resource-box/resource-box.js": [
		39247,
		9,
		15104,
		33441,
		25783,
		34670,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		14437,
		39247
	],
	"./details/common/resource-box/resource-box.scss": [
		68771,
		9,
		68771
	],
	"./details/common/resource-box/resource-boxes": [
		94653,
		9,
		15104,
		33441,
		25783,
		34670,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		14437,
		45580,
		39247,
		68771,
		94653
	],
	"./details/common/resource-box/resource-boxes.js": [
		94653,
		9,
		15104,
		33441,
		25783,
		34670,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		14437,
		45580,
		39247,
		68771,
		94653
	],
	"./details/common/resource-box/video-resource-box": [
		66115,
		7,
		15104,
		33441,
		25783,
		34670,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		14437,
		39247,
		66115
	],
	"./details/common/resource-box/video-resource-box.tsx": [
		66115,
		7,
		15104,
		33441,
		25783,
		34670,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		14437,
		39247,
		66115
	],
	"./details/common/savings-blurb": [
		9926,
		9,
		15104,
		34670,
		31291,
		86870,
		9926
	],
	"./details/common/savings-blurb.js": [
		9926,
		9,
		15104,
		34670,
		31291,
		86870,
		9926
	],
	"./details/common/savings-blurb.scss": [
		31291,
		9,
		31291
	],
	"./details/common/tab-utils": [
		56649,
		9,
		56649
	],
	"./details/common/tab-utils.js": [
		56649,
		9,
		56649
	],
	"./details/common/toc-slideout/context": [
		5719,
		9,
		5719
	],
	"./details/common/toc-slideout/context.js": [
		5719,
		9,
		5719
	],
	"./details/common/toc-slideout/toc-slideout": [
		65092,
		9,
		34670,
		63028,
		5719,
		65092
	],
	"./details/common/toc-slideout/toc-slideout.js": [
		65092,
		9,
		34670,
		63028,
		5719,
		65092
	],
	"./details/context": [
		45580,
		9,
		45580
	],
	"./details/context.d": [
		42760,
		7,
		42760
	],
	"./details/context.d.ts": [
		42760,
		7,
		42760
	],
	"./details/context.js": [
		45580,
		9,
		45580
	],
	"./details/desktop-view/desktop-view": [
		40491,
		9,
		15104,
		67913,
		34670,
		63028,
		71787,
		22151,
		45580,
		63777,
		61954,
		9009,
		71057,
		63583,
		65026,
		37698,
		78717,
		56649,
		40491
	],
	"./details/desktop-view/desktop-view.js": [
		40491,
		9,
		15104,
		67913,
		34670,
		63028,
		71787,
		22151,
		45580,
		63777,
		61954,
		9009,
		71057,
		63583,
		65026,
		37698,
		78717,
		56649,
		40491
	],
	"./details/desktop-view/desktop-view.scss": [
		37698,
		9,
		37698
	],
	"./details/desktop-view/details-tab/details-tab": [
		89237,
		9,
		15104,
		67913,
		33441,
		25783,
		34670,
		63028,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		71787,
		40172,
		24536,
		5719,
		95301,
		63777,
		28521,
		85197,
		53246,
		86952,
		6234,
		31291,
		89237
	],
	"./details/desktop-view/details-tab/details-tab.js": [
		89237,
		9,
		15104,
		67913,
		33441,
		25783,
		34670,
		63028,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		71787,
		40172,
		24536,
		5719,
		95301,
		63777,
		28521,
		85197,
		53246,
		86952,
		6234,
		31291,
		89237
	],
	"./details/desktop-view/details-tab/details-tab.scss": [
		95909,
		9,
		95909
	],
	"./details/desktop-view/instructor-resource-tab/instructor-resource-tab": [
		54833,
		9,
		15104,
		67913,
		33441,
		25783,
		34670,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		71787,
		14437,
		45580,
		39247,
		68771,
		74681,
		94653,
		58662,
		73110,
		66115,
		96900,
		9439,
		69761,
		17745
	],
	"./details/desktop-view/instructor-resource-tab/instructor-resource-tab.js": [
		54833,
		9,
		15104,
		67913,
		33441,
		25783,
		34670,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		71787,
		14437,
		45580,
		39247,
		68771,
		74681,
		94653,
		58662,
		73110,
		66115,
		96900,
		9439,
		69761,
		17745
	],
	"./details/desktop-view/instructor-resource-tab/instructor-resource-tab.scss": [
		69761,
		9,
		69761
	],
	"./details/desktop-view/instructor-resource-tab/partners/partners": [
		67869,
		9,
		15104,
		74681,
		9439,
		67869
	],
	"./details/desktop-view/instructor-resource-tab/partners/partners.js": [
		67869,
		9,
		15104,
		74681,
		9439,
		67869
	],
	"./details/desktop-view/instructor-resource-tab/partners/partners.scss": [
		9439,
		9,
		9439
	],
	"./details/desktop-view/student-resource-tab/student-resource-tab": [
		20665,
		9,
		15104,
		33441,
		25783,
		34670,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		14437,
		45580,
		39247,
		68771,
		94653,
		83000,
		20665
	],
	"./details/desktop-view/student-resource-tab/student-resource-tab.js": [
		20665,
		9,
		15104,
		33441,
		25783,
		34670,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		14437,
		45580,
		39247,
		68771,
		94653,
		83000,
		20665
	],
	"./details/desktop-view/student-resource-tab/student-resource-tab.scss": [
		83000,
		9,
		83000
	],
	"./details/desktop-view/videos-tab/videos-tab": [
		78717,
		9,
		34670,
		63583,
		78717
	],
	"./details/desktop-view/videos-tab/videos-tab.js": [
		78717,
		9,
		34670,
		63583,
		78717
	],
	"./details/desktop-view/videos-tab/videos-tab.scss": [
		63583,
		9,
		63583
	],
	"./details/details": [
		75655,
		9,
		15104,
		67913,
		33441,
		25783,
		87850,
		34670,
		68039,
		63028,
		20115,
		50295,
		50566,
		56803,
		89604,
		49374,
		42673,
		27752,
		37827,
		54873,
		20109,
		96038,
		28365,
		76536,
		81321,
		61958,
		71787,
		40172,
		22151,
		24536,
		45580,
		77662,
		9639
	],
	"./details/details.js": [
		75655,
		9,
		15104,
		67913,
		33441,
		25783,
		87850,
		34670,
		68039,
		63028,
		20115,
		50295,
		50566,
		56803,
		89604,
		49374,
		42673,
		27752,
		37827,
		54873,
		20109,
		96038,
		28365,
		76536,
		81321,
		61958,
		71787,
		40172,
		22151,
		24536,
		45580,
		77662,
		9639
	],
	"./details/details.scss": [
		67297,
		9,
		67297
	],
	"./details/dual-view": [
		50657,
		7,
		15104,
		67913,
		33441,
		25783,
		87850,
		34670,
		63028,
		50295,
		50566,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		96038,
		28365,
		76536,
		81321,
		61958,
		71787,
		40172,
		22151,
		24536,
		45580,
		5719,
		95301,
		63777,
		28521,
		77662,
		75426
	],
	"./details/dual-view.tsx": [
		50657,
		7,
		15104,
		67913,
		33441,
		25783,
		87850,
		34670,
		63028,
		50295,
		50566,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		96038,
		28365,
		76536,
		81321,
		61958,
		71787,
		40172,
		22151,
		24536,
		45580,
		5719,
		95301,
		63777,
		28521,
		77662,
		75426
	],
	"./details/phone-view/details-pane/details-pane": [
		94901,
		9,
		15104,
		67913,
		34670,
		71787,
		63777,
		31291,
		86870,
		61954,
		9009,
		71057,
		9926,
		11210,
		65026,
		94901
	],
	"./details/phone-view/details-pane/details-pane.js": [
		94901,
		9,
		15104,
		67913,
		34670,
		71787,
		63777,
		31291,
		86870,
		61954,
		9009,
		71057,
		9926,
		11210,
		65026,
		94901
	],
	"./details/phone-view/details-pane/details-pane.scss": [
		11210,
		9,
		11210
	],
	"./details/phone-view/instructor-resources-pane/instructor-resources-pane": [
		18487,
		9,
		15104,
		33441,
		25783,
		34670,
		50295,
		50566,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		14437,
		45580,
		39247,
		68771,
		94653,
		73110,
		66115,
		96900,
		38286,
		18487
	],
	"./details/phone-view/instructor-resources-pane/instructor-resources-pane.js": [
		18487,
		9,
		15104,
		33441,
		25783,
		34670,
		50295,
		50566,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		14437,
		45580,
		39247,
		68771,
		94653,
		73110,
		66115,
		96900,
		38286,
		18487
	],
	"./details/phone-view/instructor-resources-pane/instructor-resources-pane.scss": [
		38286,
		9,
		38286
	],
	"./details/phone-view/phone-view": [
		77662,
		9,
		15104,
		67913,
		33441,
		25783,
		87850,
		34670,
		63028,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		96038,
		28365,
		76536,
		81321,
		61958,
		71787,
		40172,
		24536,
		45580,
		5719,
		95301,
		63777,
		28521,
		58662,
		85197,
		77662
	],
	"./details/phone-view/phone-view.js": [
		77662,
		9,
		15104,
		67913,
		33441,
		25783,
		87850,
		34670,
		63028,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		96038,
		28365,
		76536,
		81321,
		61958,
		71787,
		40172,
		24536,
		45580,
		5719,
		95301,
		63777,
		28521,
		58662,
		85197,
		77662
	],
	"./details/phone-view/phone-view.scss": [
		61447,
		9,
		61447
	],
	"./details/phone-view/student-resources-pane/student-resources-pane": [
		27584,
		9,
		15104,
		33441,
		25783,
		34670,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		14437,
		45580,
		39247,
		68771,
		94653,
		91528,
		27584
	],
	"./details/phone-view/student-resources-pane/student-resources-pane.js": [
		27584,
		9,
		15104,
		33441,
		25783,
		34670,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		14437,
		45580,
		39247,
		68771,
		94653,
		91528,
		27584
	],
	"./details/phone-view/student-resources-pane/student-resources-pane.scss": [
		91528,
		9,
		91528
	],
	"./details/table-of-contents.scss": [
		89150,
		9,
		89150
	],
	"./details/title-image": [
		96298,
		7,
		45580,
		96298
	],
	"./details/title-image.tsx": [
		96298,
		7,
		45580,
		96298
	],
	"./errata-detail/detail/detail": [
		14763,
		9,
		34670,
		12790,
		93450,
		14763
	],
	"./errata-detail/detail/detail.js": [
		14763,
		9,
		34670,
		12790,
		93450,
		14763
	],
	"./errata-detail/detail/detail.scss": [
		93450,
		9,
		93450
	],
	"./errata-detail/errata-detail": [
		53575,
		9,
		34670,
		68039,
		20115,
		89604,
		49374,
		12790,
		95303,
		93450,
		67600,
		14763,
		40436,
		53575
	],
	"./errata-detail/errata-detail.js": [
		53575,
		9,
		34670,
		68039,
		20115,
		89604,
		49374,
		12790,
		95303,
		93450,
		67600,
		14763,
		40436,
		53575
	],
	"./errata-detail/errata-detail.scss": [
		67600,
		9,
		67600
	],
	"./errata-detail/progress-bar/progress-bar": [
		40436,
		9,
		95303,
		40436
	],
	"./errata-detail/progress-bar/progress-bar.js": [
		40436,
		9,
		95303,
		40436
	],
	"./errata-detail/progress-bar/progress-bar.scss": [
		95303,
		9,
		95303
	],
	"./errata-form/errata-form": [
		42030,
		9,
		15104,
		67913,
		34670,
		63028,
		50295,
		80370,
		20952,
		4204,
		98677,
		67953,
		71787,
		58662,
		50811,
		25153,
		59282,
		5742,
		94394,
		96948,
		41727,
		56850,
		79692,
		64032,
		92993,
		42030
	],
	"./errata-form/errata-form-context": [
		25153,
		9,
		20952,
		25153
	],
	"./errata-form/errata-form-context.js": [
		25153,
		9,
		20952,
		25153
	],
	"./errata-form/errata-form.js": [
		42030,
		9,
		15104,
		67913,
		34670,
		63028,
		50295,
		80370,
		20952,
		4204,
		98677,
		67953,
		71787,
		58662,
		50811,
		25153,
		59282,
		5742,
		94394,
		96948,
		41727,
		56850,
		79692,
		64032,
		92993,
		42030
	],
	"./errata-form/errata-form.scss": [
		92993,
		9,
		92993
	],
	"./errata-form/form/ErrorLocationSelector/ErrorLocationSelector": [
		56850,
		9,
		67913,
		20952,
		71787,
		58662,
		50811,
		25153,
		59282,
		5742,
		56850
	],
	"./errata-form/form/ErrorLocationSelector/ErrorLocationSelector.js": [
		56850,
		9,
		67913,
		20952,
		71787,
		58662,
		50811,
		25153,
		59282,
		5742,
		56850
	],
	"./errata-form/form/ErrorLocationSelector/ErrorLocationSelector.scss": [
		5742,
		9,
		5742
	],
	"./errata-form/form/ErrorLocationSelector/test-data": [
		17972,
		9,
		17972
	],
	"./errata-form/form/ErrorLocationSelector/test-data.js": [
		17972,
		9,
		17972
	],
	"./errata-form/form/ErrorLocationSelector/toc-selector": [
		59282,
		9,
		67913,
		20952,
		71787,
		58662,
		50811,
		25153,
		59282
	],
	"./errata-form/form/ErrorLocationSelector/toc-selector.js": [
		59282,
		9,
		67913,
		20952,
		71787,
		58662,
		50811,
		25153,
		59282
	],
	"./errata-form/form/ErrorSourceSelector": [
		96948,
		9,
		20952,
		50811,
		25153,
		96948
	],
	"./errata-form/form/ErrorSourceSelector.js": [
		96948,
		9,
		20952,
		50811,
		25153,
		96948
	],
	"./errata-form/form/ErrorTypeSelector": [
		41727,
		9,
		50811,
		41727
	],
	"./errata-form/form/ErrorTypeSelector.js": [
		41727,
		9,
		50811,
		41727
	],
	"./errata-form/form/FileUploader": [
		79692,
		9,
		15104,
		79692
	],
	"./errata-form/form/FileUploader.js": [
		79692,
		9,
		15104,
		79692
	],
	"./errata-form/form/InvalidMessage": [
		50811,
		9,
		50811
	],
	"./errata-form/form/InvalidMessage.js": [
		50811,
		9,
		50811
	],
	"./errata-form/form/form": [
		64032,
		9,
		15104,
		67913,
		34670,
		50295,
		20952,
		71787,
		58662,
		50811,
		25153,
		59282,
		5742,
		94394,
		96948,
		41727,
		56850,
		79692,
		64032
	],
	"./errata-form/form/form.js": [
		64032,
		9,
		15104,
		67913,
		34670,
		50295,
		20952,
		71787,
		58662,
		50811,
		25153,
		59282,
		5742,
		94394,
		96948,
		41727,
		56850,
		79692,
		64032
	],
	"./errata-form/form/form.scss": [
		94394,
		9,
		94394
	],
	"./errata-summary/errata-summary": [
		16574,
		9,
		15104,
		34670,
		68039,
		63028,
		20115,
		89604,
		49374,
		12790,
		9767,
		87223,
		42957,
		53500,
		38773,
		23231,
		16574
	],
	"./errata-summary/errata-summary.js": [
		16574,
		9,
		15104,
		34670,
		68039,
		63028,
		20115,
		89604,
		49374,
		12790,
		9767,
		87223,
		42957,
		53500,
		38773,
		23231,
		16574
	],
	"./errata-summary/errata-summary.scss": [
		23231,
		9,
		23231
	],
	"./errata-summary/hero/hero": [
		38773,
		9,
		15104,
		34670,
		68039,
		20115,
		89604,
		49374,
		42957,
		38773
	],
	"./errata-summary/hero/hero.js": [
		38773,
		9,
		15104,
		34670,
		68039,
		20115,
		89604,
		49374,
		42957,
		38773
	],
	"./errata-summary/hero/hero.scss": [
		42957,
		9,
		42957
	],
	"./errata-summary/table/table": [
		53500,
		9,
		63028,
		12790,
		87223,
		53500
	],
	"./errata-summary/table/table.js": [
		53500,
		9,
		63028,
		12790,
		87223,
		53500
	],
	"./errata-summary/table/table.scss": [
		87223,
		9,
		87223
	],
	"./faq/faq": [
		90011,
		9,
		34670,
		68039,
		20115,
		89604,
		49374,
		55845,
		90011
	],
	"./faq/faq.js": [
		90011,
		9,
		34670,
		68039,
		20115,
		89604,
		49374,
		55845,
		90011
	],
	"./faq/faq.scss": [
		55845,
		9,
		55845
	],
	"./footer-page/footer-page": [
		67620,
		9,
		34670,
		68039,
		33009,
		67620
	],
	"./footer-page/footer-page.js": [
		67620,
		9,
		34670,
		68039,
		33009,
		67620
	],
	"./footer-page/footer-page.scss": [
		33009,
		9,
		33009
	],
	"./foundation/foundation": [
		41911,
		9,
		34670,
		68039,
		20115,
		89604,
		49374,
		13831,
		34197,
		41911
	],
	"./foundation/foundation.js": [
		41911,
		9,
		34670,
		68039,
		20115,
		89604,
		49374,
		13831,
		34197,
		41911
	],
	"./foundation/foundation.scss": [
		34197,
		9,
		34197
	],
	"./general/general": [
		81568,
		9,
		34670,
		20115,
		53452,
		81568
	],
	"./general/general.js": [
		81568,
		9,
		34670,
		20115,
		53452,
		81568
	],
	"./general/general.scss": [
		53452,
		9,
		53452
	],
	"./global-reach/global-reach": [
		36624,
		9,
		15104,
		68039,
		20115,
		89604,
		49374,
		82246,
		92195,
		99284,
		50741,
		29587,
		33007,
		65731,
		45365,
		36624
	],
	"./global-reach/global-reach.js": [
		36624,
		9,
		15104,
		68039,
		20115,
		89604,
		49374,
		82246,
		92195,
		99284,
		50741,
		29587,
		33007,
		65731,
		45365,
		36624
	],
	"./global-reach/map/map": [
		45365,
		9,
		92195,
		45365
	],
	"./global-reach/map/map.js": [
		45365,
		9,
		92195,
		45365
	],
	"./global-reach/map/map.scss": [
		92195,
		9,
		92195
	],
	"./global-reach/schoolmap/schoolmap": [
		33007,
		9,
		15104,
		50741,
		33007
	],
	"./global-reach/schoolmap/schoolmap.js": [
		33007,
		9,
		15104,
		50741,
		33007
	],
	"./global-reach/schoolmap/schoolmap.scss": [
		50741,
		9,
		50741
	],
	"./global-reach/statistics/stat": [
		65731,
		9,
		99284,
		65731
	],
	"./global-reach/statistics/stat.js": [
		65731,
		9,
		99284,
		65731
	],
	"./global-reach/statistics/stat.scss": [
		99284,
		9,
		99284
	],
	"./global-reach/studentinfo/studentinfo": [
		29587,
		9,
		82246,
		29587
	],
	"./global-reach/studentinfo/studentinfo.js": [
		29587,
		9,
		82246,
		29587
	],
	"./global-reach/studentinfo/studentinfo.scss": [
		82246,
		9,
		82246
	],
	"./home/banner/banner": [
		9308,
		9,
		34670,
		84230,
		13831,
		84573,
		9308
	],
	"./home/banner/banner.js": [
		9308,
		9,
		34670,
		84230,
		13831,
		84573,
		9308
	],
	"./home/banner/banner.scss": [
		84573,
		9,
		84573
	],
	"./home/features/features": [
		73146,
		9,
		15104,
		84230,
		32562,
		73146
	],
	"./home/features/features.js": [
		73146,
		9,
		15104,
		84230,
		32562,
		73146
	],
	"./home/features/features.scss": [
		32562,
		9,
		32562
	],
	"./home/home": [
		13278,
		9,
		15104,
		80570,
		34670,
		68039,
		20115,
		89604,
		49374,
		84230,
		13831,
		53920,
		23245,
		32562,
		88866,
		37396,
		84573,
		63686,
		73146,
		9308,
		59385,
		78339,
		5687,
		29080,
		13278
	],
	"./home/home.js": [
		13278,
		9,
		15104,
		80570,
		34670,
		68039,
		20115,
		89604,
		49374,
		84230,
		13831,
		53920,
		23245,
		32562,
		88866,
		37396,
		84573,
		63686,
		73146,
		9308,
		59385,
		78339,
		5687,
		29080,
		13278
	],
	"./home/home.scss": [
		63686,
		9,
		63686
	],
	"./home/map/map": [
		29080,
		9,
		34670,
		37396,
		29080
	],
	"./home/map/map.js": [
		29080,
		9,
		34670,
		37396,
		29080
	],
	"./home/map/map.scss": [
		37396,
		9,
		37396
	],
	"./home/overlapping-boxes/overlapping-boxes": [
		5687,
		9,
		23245,
		5687
	],
	"./home/overlapping-boxes/overlapping-boxes.js": [
		5687,
		9,
		23245,
		5687
	],
	"./home/overlapping-boxes/overlapping-boxes.scss": [
		23245,
		9,
		23245
	],
	"./home/quotes/quotes": [
		59385,
		9,
		34670,
		84230,
		53920,
		59385
	],
	"./home/quotes/quotes.js": [
		59385,
		9,
		34670,
		84230,
		53920,
		59385
	],
	"./home/quotes/quotes.scss": [
		53920,
		9,
		53920
	],
	"./home/whats-openstax/whats-openstax": [
		78339,
		9,
		84230,
		13831,
		88866,
		78339
	],
	"./home/whats-openstax/whats-openstax.js": [
		78339,
		9,
		84230,
		13831,
		88866,
		78339
	],
	"./home/whats-openstax/whats-openstax.scss": [
		88866,
		9,
		88866
	],
	"./impact/disruption": [
		43341,
		9,
		72511,
		43341
	],
	"./impact/disruption.js": [
		43341,
		9,
		72511,
		43341
	],
	"./impact/disruption.scss": [
		72511,
		9,
		72511
	],
	"./impact/give": [
		79675,
		9,
		79103,
		79675
	],
	"./impact/give.js": [
		79675,
		9,
		79103,
		79675
	],
	"./impact/give.scss": [
		79103,
		9,
		79103
	],
	"./impact/impact": [
		62309,
		9,
		15104,
		80570,
		34670,
		68039,
		20115,
		50295,
		50566,
		33948,
		89604,
		49374,
		30604,
		3115,
		13831,
		80550,
		6771,
		7691,
		67775,
		70015,
		35233,
		79103,
		83563,
		59730,
		72511,
		83818,
		64302,
		60020,
		30806,
		79675,
		43341,
		62309
	],
	"./impact/impact.js": [
		62309,
		9,
		15104,
		80570,
		34670,
		68039,
		20115,
		50295,
		50566,
		33948,
		89604,
		49374,
		30604,
		3115,
		13831,
		80550,
		6771,
		7691,
		67775,
		70015,
		35233,
		79103,
		83563,
		59730,
		72511,
		83818,
		64302,
		60020,
		30806,
		79675,
		43341,
		62309
	],
	"./impact/impact.scss": [
		83818,
		9,
		83818
	],
	"./impact/our-reach": [
		60020,
		9,
		15104,
		34670,
		50566,
		30604,
		13831,
		35233,
		59730,
		60020
	],
	"./impact/our-reach.js": [
		60020,
		9,
		15104,
		34670,
		50566,
		30604,
		13831,
		35233,
		59730,
		60020
	],
	"./impact/our-reach.scss": [
		59730,
		9,
		59730
	],
	"./impact/quote": [
		30806,
		9,
		34670,
		83563,
		30806
	],
	"./impact/quote.js": [
		30806,
		9,
		34670,
		83563,
		30806
	],
	"./impact/quote.scss": [
		83563,
		9,
		83563
	],
	"./impact/testimonials": [
		64302,
		9,
		15104,
		34670,
		68039,
		20115,
		50295,
		50566,
		33948,
		30604,
		3115,
		13831,
		80550,
		6771,
		7691,
		67775,
		70015,
		64302
	],
	"./impact/testimonials.js": [
		64302,
		9,
		15104,
		34670,
		68039,
		20115,
		50295,
		50566,
		33948,
		30604,
		3115,
		13831,
		80550,
		6771,
		7691,
		67775,
		70015,
		64302
	],
	"./impact/testimonials.scss": [
		70015,
		9,
		70015
	],
	"./institutional-partnership-application/institutional-partnership-application": [
		96870,
		9,
		67913,
		34670,
		68039,
		20115,
		89604,
		49374,
		87941,
		96870
	],
	"./institutional-partnership-application/institutional-partnership-application.js": [
		96870,
		9,
		67913,
		34670,
		68039,
		20115,
		89604,
		49374,
		87941,
		96870
	],
	"./institutional-partnership-application/institutional-partnership-application.scss": [
		87941,
		9,
		87941
	],
	"./institutional-partnership/institutional-partnership": [
		99319,
		9,
		15104,
		67913,
		80570,
		34670,
		68039,
		20115,
		50295,
		50566,
		89604,
		49374,
		84230,
		89465,
		21815,
		35480,
		98655,
		71439,
		40659,
		48532,
		43542,
		38642,
		88062,
		79211,
		28106,
		93973,
		87525,
		43787,
		58868,
		5973,
		62400,
		99319
	],
	"./institutional-partnership/institutional-partnership.js": [
		99319,
		9,
		15104,
		67913,
		80570,
		34670,
		68039,
		20115,
		50295,
		50566,
		89604,
		49374,
		84230,
		89465,
		21815,
		35480,
		98655,
		71439,
		40659,
		48532,
		43542,
		38642,
		88062,
		79211,
		28106,
		93973,
		87525,
		43787,
		58868,
		5973,
		62400,
		99319
	],
	"./institutional-partnership/institutional-partnership.scss": [
		87525,
		9,
		87525
	],
	"./institutional-partnership/sections/about/about": [
		965,
		9,
		34670,
		84230,
		28106,
		965
	],
	"./institutional-partnership/sections/about/about.js": [
		965,
		9,
		34670,
		84230,
		28106,
		965
	],
	"./institutional-partnership/sections/about/about.scss": [
		28106,
		9,
		28106
	],
	"./institutional-partnership/sections/banner/banner": [
		50003,
		9,
		34670,
		84230,
		38642,
		50003
	],
	"./institutional-partnership/sections/banner/banner.js": [
		50003,
		9,
		34670,
		84230,
		38642,
		50003
	],
	"./institutional-partnership/sections/banner/banner.scss": [
		38642,
		9,
		38642
	],
	"./institutional-partnership/sections/big-quote/big-quote": [
		62400,
		9,
		84230,
		35480,
		62400
	],
	"./institutional-partnership/sections/big-quote/big-quote.js": [
		62400,
		9,
		84230,
		35480,
		62400
	],
	"./institutional-partnership/sections/big-quote/big-quote.scss": [
		35480,
		9,
		35480
	],
	"./institutional-partnership/sections/overlapping-quote/overlapping-quote": [
		76995,
		9,
		40659,
		76995
	],
	"./institutional-partnership/sections/overlapping-quote/overlapping-quote.js": [
		76995,
		9,
		40659,
		76995
	],
	"./institutional-partnership/sections/overlapping-quote/overlapping-quote.scss": [
		40659,
		9,
		40659
	],
	"./institutional-partnership/sections/participants/established-partners/established-partners": [
		93973,
		9,
		21815,
		93973
	],
	"./institutional-partnership/sections/participants/established-partners/established-partners.js": [
		93973,
		9,
		21815,
		93973
	],
	"./institutional-partnership/sections/participants/established-partners/established-partners.scss": [
		21815,
		9,
		21815
	],
	"./institutional-partnership/sections/participants/participants": [
		43787,
		9,
		15104,
		67913,
		34670,
		50295,
		21815,
		79211,
		93973,
		43787
	],
	"./institutional-partnership/sections/participants/participants.js": [
		43787,
		9,
		15104,
		67913,
		34670,
		50295,
		21815,
		79211,
		93973,
		43787
	],
	"./institutional-partnership/sections/participants/participants.scss": [
		79211,
		9,
		79211
	],
	"./institutional-partnership/sections/promoting/promoting": [
		58868,
		9,
		34670,
		71439,
		58868
	],
	"./institutional-partnership/sections/promoting/promoting.js": [
		58868,
		9,
		34670,
		71439,
		58868
	],
	"./institutional-partnership/sections/promoting/promoting.scss": [
		71439,
		9,
		71439
	],
	"./institutional-partnership/sections/results/results": [
		5973,
		9,
		34670,
		43542,
		5973
	],
	"./institutional-partnership/sections/results/results.js": [
		5973,
		9,
		34670,
		43542,
		5973
	],
	"./institutional-partnership/sections/results/results.scss": [
		43542,
		9,
		43542
	],
	"./institutional-partnership/sections/sign-up/sign-up": [
		9667,
		9,
		15104,
		34670,
		98655,
		9667
	],
	"./institutional-partnership/sections/sign-up/sign-up.js": [
		9667,
		9,
		15104,
		34670,
		98655,
		9667
	],
	"./institutional-partnership/sections/sign-up/sign-up.scss": [
		98655,
		9,
		98655
	],
	"./institutional-partnership/sections/small-quote/small-quote": [
		85269,
		9,
		88062,
		85269
	],
	"./institutional-partnership/sections/small-quote/small-quote.js": [
		85269,
		9,
		88062,
		85269
	],
	"./institutional-partnership/sections/small-quote/small-quote.scss": [
		88062,
		9,
		88062
	],
	"./institutional-partnership/sections/speaking/speaking": [
		90558,
		9,
		34670,
		48532,
		90558
	],
	"./institutional-partnership/sections/speaking/speaking.js": [
		90558,
		9,
		34670,
		48532,
		90558
	],
	"./institutional-partnership/sections/speaking/speaking.scss": [
		48532,
		9,
		48532
	],
	"./interest/interest": [
		75433,
		9,
		15104,
		34670,
		68039,
		63028,
		20115,
		89604,
		49374,
		80370,
		20952,
		4204,
		98677,
		67953,
		89465,
		30703,
		63667,
		29424,
		56134,
		98098,
		442,
		27810,
		75433
	],
	"./interest/interest.js": [
		75433,
		9,
		15104,
		34670,
		68039,
		63028,
		20115,
		89604,
		49374,
		80370,
		20952,
		4204,
		98677,
		67953,
		89465,
		30703,
		63667,
		29424,
		56134,
		98098,
		442,
		27810,
		75433
	],
	"./interest/interest.scss": [
		27810,
		9,
		27810
	],
	"./k12/all-subjects/all-subjects": [
		47138,
		9,
		15104,
		67913,
		87850,
		80570,
		34670,
		68039,
		63028,
		20115,
		50566,
		89604,
		49374,
		84230,
		96038,
		80370,
		20952,
		4204,
		98677,
		67953,
		89465,
		30703,
		63667,
		29424,
		56134,
		98098,
		442,
		27810,
		69994,
		75433,
		9767,
		47138
	],
	"./k12/all-subjects/all-subjects.js": [
		47138,
		9,
		15104,
		67913,
		87850,
		80570,
		34670,
		68039,
		63028,
		20115,
		50566,
		89604,
		49374,
		84230,
		96038,
		80370,
		20952,
		4204,
		98677,
		67953,
		89465,
		30703,
		63667,
		29424,
		56134,
		98098,
		442,
		27810,
		69994,
		75433,
		9767,
		47138
	],
	"./k12/all-subjects/all-subjects.scss": [
		67549,
		9,
		67549
	],
	"./k12/all-subjects/banner": [
		28597,
		9,
		34670,
		84230,
		31374,
		28597
	],
	"./k12/all-subjects/banner.js": [
		28597,
		9,
		34670,
		84230,
		31374,
		28597
	],
	"./k12/all-subjects/banner.scss": [
		31374,
		9,
		31374
	],
	"./k12/all-subjects/faq": [
		48269,
		9,
		15104,
		87850,
		34670,
		96038,
		69994,
		49968,
		48269
	],
	"./k12/all-subjects/faq.js": [
		48269,
		9,
		15104,
		87850,
		34670,
		96038,
		69994,
		49968,
		48269
	],
	"./k12/all-subjects/faq.scss": [
		49968,
		9,
		49968
	],
	"./k12/all-subjects/features": [
		39383,
		9,
		34670,
		71030,
		39383
	],
	"./k12/all-subjects/features.js": [
		39383,
		9,
		34670,
		71030,
		39383
	],
	"./k12/all-subjects/features.scss": [
		71030,
		9,
		71030
	],
	"./k12/all-subjects/sign-up-form": [
		38074,
		9,
		15104,
		34670,
		68039,
		63028,
		20115,
		89604,
		49374,
		80370,
		20952,
		4204,
		98677,
		67953,
		89465,
		30703,
		63667,
		29424,
		56134,
		98098,
		442,
		27810,
		75433,
		49227,
		38074
	],
	"./k12/all-subjects/sign-up-form.js": [
		38074,
		9,
		15104,
		34670,
		68039,
		63028,
		20115,
		89604,
		49374,
		80370,
		20952,
		4204,
		98677,
		67953,
		89465,
		30703,
		63667,
		29424,
		56134,
		98098,
		442,
		27810,
		75433,
		49227,
		38074
	],
	"./k12/all-subjects/sign-up-form.scss": [
		49227,
		9,
		49227
	],
	"./k12/all-subjects/stats-grid": [
		66013,
		9,
		15104,
		34670,
		84230,
		73908,
		66013
	],
	"./k12/all-subjects/stats-grid.js": [
		66013,
		9,
		15104,
		34670,
		84230,
		73908,
		66013
	],
	"./k12/all-subjects/stats-grid.scss": [
		73908,
		9,
		73908
	],
	"./k12/all-subjects/subjects": [
		69078,
		9,
		15104,
		67913,
		34670,
		84230,
		9767,
		37176,
		69078
	],
	"./k12/all-subjects/subjects.js": [
		69078,
		9,
		15104,
		67913,
		34670,
		84230,
		9767,
		37176,
		69078
	],
	"./k12/all-subjects/subjects.scss": [
		37176,
		9,
		37176
	],
	"./k12/all-subjects/testimonial": [
		22697,
		9,
		34670,
		50566,
		14246,
		22697
	],
	"./k12/all-subjects/testimonial.js": [
		22697,
		9,
		34670,
		50566,
		14246,
		22697
	],
	"./k12/all-subjects/testimonial.scss": [
		14246,
		9,
		14246
	],
	"./k12/k12": [
		82298,
		9,
		82298
	],
	"./k12/k12.js": [
		82298,
		9,
		82298
	],
	"./k12/shared/contact-form": [
		18354,
		9,
		34670,
		71716,
		18354
	],
	"./k12/shared/contact-form.js": [
		18354,
		9,
		34670,
		71716,
		18354
	],
	"./k12/shared/contact-form.scss": [
		71716,
		9,
		71716
	],
	"./k12/subject/banner": [
		80904,
		9,
		34670,
		84230,
		95742,
		80904
	],
	"./k12/subject/banner.js": [
		80904,
		9,
		34670,
		84230,
		95742,
		80904
	],
	"./k12/subject/banner.scss": [
		95742,
		9,
		95742
	],
	"./k12/subject/blogs": [
		59302,
		9,
		79789,
		59302
	],
	"./k12/subject/blogs.js": [
		59302,
		9,
		79789,
		59302
	],
	"./k12/subject/blogs.scss": [
		79789,
		9,
		79789
	],
	"./k12/subject/books": [
		34260,
		9,
		15104,
		33441,
		25783,
		87850,
		34670,
		63028,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		96038,
		28365,
		76536,
		81321,
		61958,
		40172,
		24536,
		5719,
		95301,
		28521,
		85197,
		53246,
		86952,
		6234,
		82017,
		69994,
		34260
	],
	"./k12/subject/books.js": [
		34260,
		9,
		15104,
		33441,
		25783,
		87850,
		34670,
		63028,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		96038,
		28365,
		76536,
		81321,
		61958,
		40172,
		24536,
		5719,
		95301,
		28521,
		85197,
		53246,
		86952,
		6234,
		82017,
		69994,
		34260
	],
	"./k12/subject/books.scss": [
		96011,
		9,
		96011
	],
	"./k12/subject/contact": [
		23796,
		9,
		15104,
		34670,
		68039,
		63028,
		20115,
		89604,
		49374,
		80370,
		20952,
		4204,
		98677,
		67953,
		89465,
		30703,
		63667,
		29424,
		56134,
		98098,
		442,
		27810,
		75433,
		64972,
		23796
	],
	"./k12/subject/contact.js": [
		23796,
		9,
		15104,
		34670,
		68039,
		63028,
		20115,
		89604,
		49374,
		80370,
		20952,
		4204,
		98677,
		67953,
		89465,
		30703,
		63667,
		29424,
		56134,
		98098,
		442,
		27810,
		75433,
		64972,
		23796
	],
	"./k12/subject/contact.scss": [
		64972,
		9,
		64972
	],
	"./k12/subject/resources": [
		94133,
		9,
		63028,
		22151,
		91378,
		94133
	],
	"./k12/subject/resources.js": [
		94133,
		9,
		63028,
		22151,
		91378,
		94133
	],
	"./k12/subject/resources.scss": [
		91378,
		9,
		91378
	],
	"./k12/subject/subject": [
		1846,
		9,
		15104,
		33441,
		25783,
		87850,
		34670,
		68039,
		63028,
		20115,
		50295,
		56803,
		89604,
		49374,
		42673,
		27752,
		37827,
		54873,
		20109,
		84230,
		96038,
		80370,
		28365,
		76536,
		81321,
		61958,
		20952,
		4204,
		98677,
		67953,
		89465,
		1846
	],
	"./k12/subject/subject.js": [
		1846,
		9,
		15104,
		33441,
		25783,
		87850,
		34670,
		68039,
		63028,
		20115,
		50295,
		56803,
		89604,
		49374,
		42673,
		27752,
		37827,
		54873,
		20109,
		84230,
		96038,
		80370,
		28365,
		76536,
		81321,
		61958,
		20952,
		4204,
		98677,
		67953,
		89465,
		1846
	],
	"./k12/subject/subject.scss": [
		24157,
		9,
		24157
	],
	"./llph/llph": [
		4704,
		9,
		34670,
		68039,
		20115,
		89604,
		49374,
		64305,
		4704
	],
	"./llph/llph.js": [
		4704,
		9,
		34670,
		68039,
		20115,
		89604,
		49374,
		64305,
		4704
	],
	"./llph/llph.scss": [
		64305,
		9,
		64305
	],
	"./partners/active-filters/active-filters": [
		27779,
		9,
		90689,
		42350,
		46535,
		27779
	],
	"./partners/active-filters/active-filters.js": [
		27779,
		9,
		90689,
		42350,
		46535,
		27779
	],
	"./partners/active-filters/active-filters.scss": [
		42350,
		9,
		42350
	],
	"./partners/active-filters/filter-remover": [
		46535,
		9,
		46535
	],
	"./partners/active-filters/filter-remover.js": [
		46535,
		9,
		46535
	],
	"./partners/controls/advanced-options/advanced-options": [
		44165,
		9,
		15104,
		67913,
		87850,
		63028,
		96038,
		35056,
		19967,
		44165
	],
	"./partners/controls/advanced-options/advanced-options.js": [
		44165,
		9,
		15104,
		67913,
		87850,
		63028,
		96038,
		35056,
		19967,
		44165
	],
	"./partners/controls/book-options/book-options": [
		52079,
		9,
		15104,
		63028,
		20952,
		35056,
		19967,
		14274,
		52079
	],
	"./partners/controls/book-options/book-options.js": [
		52079,
		9,
		15104,
		63028,
		20952,
		35056,
		19967,
		14274,
		52079
	],
	"./partners/controls/book-options/book-options.scss": [
		14274,
		9,
		14274
	],
	"./partners/controls/button-with-popover.scss": [
		14186,
		9,
		14186
	],
	"./partners/controls/checkboxes-linked-to-store/checkboxes-linked-to-store": [
		19967,
		9,
		15104,
		63028,
		35056,
		19967
	],
	"./partners/controls/checkboxes-linked-to-store/checkboxes-linked-to-store.js": [
		19967,
		9,
		15104,
		63028,
		35056,
		19967
	],
	"./partners/controls/checkboxes-linked-to-store/checkboxes-linked-to-store.scss": [
		35056,
		9,
		35056
	],
	"./partners/controls/controls": [
		79712,
		9,
		15104,
		67913,
		87850,
		63028,
		96038,
		20952,
		89465,
		90689,
		35056,
		19967,
		14274,
		36799,
		62728,
		14186,
		44165,
		95140,
		52079,
		79712
	],
	"./partners/controls/controls.js": [
		79712,
		9,
		15104,
		67913,
		87850,
		63028,
		96038,
		20952,
		89465,
		90689,
		35056,
		19967,
		14274,
		36799,
		62728,
		14186,
		44165,
		95140,
		52079,
		79712
	],
	"./partners/controls/controls.scss": [
		62728,
		9,
		62728
	],
	"./partners/controls/options-list/options-list": [
		95140,
		9,
		63028,
		36799,
		95140
	],
	"./partners/controls/options-list/options-list.js": [
		95140,
		9,
		63028,
		36799,
		95140
	],
	"./partners/controls/options-list/options-list.scss": [
		36799,
		9,
		36799
	],
	"./partners/mobile-controls/mobile-controls": [
		10278,
		9,
		15104,
		67913,
		87850,
		63028,
		50566,
		96038,
		20952,
		89465,
		90689,
		35056,
		19967,
		14274,
		36799,
		62728,
		14186,
		42350,
		44165,
		95140,
		52079,
		46535,
		29848,
		79712,
		27779,
		10278
	],
	"./partners/mobile-controls/mobile-controls.js": [
		10278,
		9,
		15104,
		67913,
		87850,
		63028,
		50566,
		96038,
		20952,
		89465,
		90689,
		35056,
		19967,
		14274,
		36799,
		62728,
		14186,
		42350,
		44165,
		95140,
		52079,
		46535,
		29848,
		79712,
		27779,
		10278
	],
	"./partners/mobile-controls/mobile-controls.scss": [
		29848,
		9,
		29848
	],
	"./partners/partner-details/carousel/carousel": [
		12943,
		9,
		15104,
		50566,
		3115,
		8994,
		12943
	],
	"./partners/partner-details/carousel/carousel.js": [
		12943,
		9,
		15104,
		50566,
		3115,
		8994,
		12943
	],
	"./partners/partner-details/carousel/carousel.scss": [
		8994,
		9,
		8994
	],
	"./partners/partner-details/info-request-form/info-request-form": [
		37370,
		9,
		15104,
		67913,
		63028,
		80370,
		20952,
		4204,
		98677,
		67953,
		89465,
		30703,
		63667,
		29424,
		56134,
		95836,
		22667,
		90689,
		74730,
		88938,
		37370
	],
	"./partners/partner-details/info-request-form/info-request-form.js": [
		37370,
		9,
		15104,
		67913,
		63028,
		80370,
		20952,
		4204,
		98677,
		67953,
		89465,
		30703,
		63667,
		29424,
		56134,
		95836,
		22667,
		90689,
		74730,
		88938,
		37370
	],
	"./partners/partner-details/info-request-form/info-request-form.scss": [
		88938,
		9,
		88938
	],
	"./partners/partner-details/partner-context": [
		22667,
		9,
		67913,
		95836,
		22667
	],
	"./partners/partner-details/partner-context.js": [
		22667,
		9,
		67913,
		95836,
		22667
	],
	"./partners/partner-details/partner-details": [
		30527,
		9,
		15104,
		67913,
		34670,
		63028,
		50566,
		80370,
		20952,
		4204,
		98677,
		67953,
		89465,
		3115,
		30703,
		22151,
		63667,
		29424,
		56134,
		74681,
		95836,
		22667,
		90689,
		74730,
		93359,
		88938,
		8994,
		37370,
		88734,
		5853,
		12943,
		30527
	],
	"./partners/partner-details/partner-details.js": [
		30527,
		9,
		15104,
		67913,
		34670,
		63028,
		50566,
		80370,
		20952,
		4204,
		98677,
		67953,
		89465,
		3115,
		30703,
		22151,
		63667,
		29424,
		56134,
		74681,
		95836,
		22667,
		90689,
		74730,
		93359,
		88938,
		8994,
		37370,
		88734,
		5853,
		12943,
		30527
	],
	"./partners/partner-details/partner-details.scss": [
		88734,
		9,
		88734
	],
	"./partners/partner-details/reviews/page-context": [
		36117,
		9,
		36117
	],
	"./partners/partner-details/reviews/page-context.js": [
		36117,
		9,
		36117
	],
	"./partners/partner-details/reviews/rating-form": [
		18777,
		9,
		15104,
		67913,
		34670,
		95836,
		22667,
		35930,
		36117,
		18777
	],
	"./partners/partner-details/reviews/rating-form.js": [
		18777,
		9,
		15104,
		67913,
		34670,
		95836,
		22667,
		35930,
		36117,
		18777
	],
	"./partners/partner-details/reviews/rating-form.scss": [
		35930,
		9,
		35930
	],
	"./partners/partner-details/reviews/review-context": [
		78277,
		7,
		78277
	],
	"./partners/partner-details/reviews/review-context.js": [
		78277,
		7,
		78277
	],
	"./partners/partner-details/reviews/reviews": [
		24644,
		9,
		15104,
		67913,
		34670,
		74681,
		95836,
		22667,
		35930,
		36117,
		18777,
		7535,
		13874,
		31333,
		24644
	],
	"./partners/partner-details/reviews/reviews.js": [
		24644,
		9,
		15104,
		67913,
		34670,
		74681,
		95836,
		22667,
		35930,
		36117,
		18777,
		7535,
		13874,
		31333,
		24644
	],
	"./partners/partner-details/reviews/reviews.scss": [
		31333,
		9,
		31333
	],
	"./partners/partner-details/reviews/user-review": [
		13874,
		9,
		15104,
		67913,
		34670,
		74681,
		95836,
		22667,
		35930,
		36117,
		18777,
		7535,
		13874
	],
	"./partners/partner-details/reviews/user-review.js": [
		13874,
		9,
		15104,
		67913,
		34670,
		74681,
		95836,
		22667,
		35930,
		36117,
		18777,
		7535,
		13874
	],
	"./partners/partner-details/reviews/user-review.scss": [
		7535,
		9,
		7535
	],
	"./partners/partner-details/synopsis/synopsis": [
		5853,
		9,
		15104,
		74681,
		93359,
		5853
	],
	"./partners/partner-details/synopsis/synopsis.js": [
		5853,
		9,
		15104,
		74681,
		93359,
		5853
	],
	"./partners/partner-details/synopsis/synopsis.scss": [
		93359,
		9,
		93359
	],
	"./partners/partners": [
		38003,
		9,
		15104,
		67913,
		87850,
		34670,
		68039,
		63028,
		20115,
		50295,
		50566,
		89604,
		49374,
		96038,
		80370,
		20952,
		4204,
		98677,
		67953,
		89465,
		3115,
		30703,
		22151,
		63667,
		29424,
		56134,
		74681,
		95836,
		22667,
		90689,
		35056,
		38003
	],
	"./partners/partners.js": [
		38003,
		9,
		15104,
		67913,
		87850,
		34670,
		68039,
		63028,
		20115,
		50295,
		50566,
		89604,
		49374,
		96038,
		80370,
		20952,
		4204,
		98677,
		67953,
		89465,
		3115,
		30703,
		22151,
		63667,
		29424,
		56134,
		74681,
		95836,
		22667,
		90689,
		35056,
		38003
	],
	"./partners/partners.scss": [
		411,
		9,
		411
	],
	"./partners/results/dialog-context": [
		95836,
		9,
		95836
	],
	"./partners/results/dialog-context.js": [
		95836,
		9,
		95836
	],
	"./partners/results/result-grid": [
		20866,
		9,
		15104,
		67913,
		34670,
		63028,
		50295,
		50566,
		80370,
		20952,
		4204,
		98677,
		67953,
		89465,
		3115,
		30703,
		22151,
		63667,
		29424,
		56134,
		74681,
		95836,
		22667,
		90689,
		74730,
		93359,
		88938,
		8994,
		37370,
		88734,
		5853,
		20866
	],
	"./partners/results/result-grid.js": [
		20866,
		9,
		15104,
		67913,
		34670,
		63028,
		50295,
		50566,
		80370,
		20952,
		4204,
		98677,
		67953,
		89465,
		3115,
		30703,
		22151,
		63667,
		29424,
		56134,
		74681,
		95836,
		22667,
		90689,
		74730,
		93359,
		88938,
		8994,
		37370,
		88734,
		5853,
		20866
	],
	"./partners/results/results": [
		41882,
		9,
		15104,
		67913,
		34670,
		63028,
		50295,
		50566,
		80370,
		20952,
		4204,
		98677,
		67953,
		89465,
		3115,
		30703,
		22151,
		63667,
		29424,
		56134,
		74681,
		95836,
		22667,
		90689,
		74730,
		93359,
		88938,
		8994,
		37370,
		88734,
		5853,
		41882
	],
	"./partners/results/results.js": [
		41882,
		9,
		15104,
		67913,
		34670,
		63028,
		50295,
		50566,
		80370,
		20952,
		4204,
		98677,
		67953,
		89465,
		3115,
		30703,
		22151,
		63667,
		29424,
		56134,
		74681,
		95836,
		22667,
		90689,
		74730,
		93359,
		88938,
		8994,
		37370,
		88734,
		5853,
		41882
	],
	"./partners/results/results.scss": [
		50860,
		9,
		50860
	],
	"./partners/search-context": [
		90689,
		9,
		90689
	],
	"./partners/search-context.js": [
		90689,
		9,
		90689
	],
	"./press/about-openstax/about-openstax": [
		81311,
		9,
		34670,
		68039,
		84114,
		81311
	],
	"./press/about-openstax/about-openstax.js": [
		81311,
		9,
		34670,
		68039,
		84114,
		81311
	],
	"./press/article/article": [
		89392,
		9,
		34670,
		68039,
		33948,
		80550,
		6771,
		75547,
		89392
	],
	"./press/article/article.js": [
		89392,
		9,
		34670,
		68039,
		33948,
		80550,
		6771,
		75547,
		89392
	],
	"./press/article/article.scss": [
		75547,
		9,
		75547
	],
	"./press/banner/banner": [
		97776,
		9,
		68039,
		84114,
		47943,
		97776
	],
	"./press/banner/banner.js": [
		97776,
		9,
		68039,
		84114,
		47943,
		97776
	],
	"./press/banner/banner.scss": [
		47943,
		9,
		47943
	],
	"./press/faq/faq": [
		43010,
		9,
		15104,
		87850,
		34670,
		68039,
		96038,
		84114,
		75045,
		43010
	],
	"./press/faq/faq.js": [
		43010,
		9,
		15104,
		87850,
		34670,
		68039,
		96038,
		84114,
		75045,
		43010
	],
	"./press/faq/faq.scss": [
		75045,
		9,
		75045
	],
	"./press/featured-in/featured-in": [
		65524,
		9,
		68039,
		84114,
		2130,
		65524
	],
	"./press/featured-in/featured-in.js": [
		65524,
		9,
		68039,
		84114,
		2130,
		65524
	],
	"./press/featured-in/featured-in.scss": [
		2130,
		9,
		2130
	],
	"./press/helpers": [
		71352,
		9,
		15104,
		33948,
		71352
	],
	"./press/helpers.js": [
		71352,
		9,
		15104,
		33948,
		71352
	],
	"./press/infographic/infographic": [
		68912,
		9,
		68039,
		84114,
		68912
	],
	"./press/infographic/infographic.js": [
		68912,
		9,
		68039,
		84114,
		68912
	],
	"./press/mission/inquiries": [
		12638,
		9,
		15104,
		68039,
		84114,
		97521,
		12638
	],
	"./press/mission/inquiries.js": [
		12638,
		9,
		15104,
		68039,
		84114,
		97521,
		12638
	],
	"./press/mission/inquiries.scss": [
		97521,
		9,
		97521
	],
	"./press/mission/leadership": [
		77897,
		9,
		34670,
		68039,
		84114,
		6404,
		77897
	],
	"./press/mission/leadership.js": [
		77897,
		9,
		34670,
		68039,
		84114,
		6404,
		77897
	],
	"./press/mission/leadership.scss": [
		6404,
		9,
		6404
	],
	"./press/mission/mission": [
		11732,
		9,
		15104,
		34670,
		68039,
		84114,
		97521,
		6404,
		12638,
		77897,
		11732
	],
	"./press/mission/mission.js": [
		11732,
		9,
		15104,
		34670,
		68039,
		84114,
		97521,
		6404,
		12638,
		77897,
		11732
	],
	"./press/news-mentions/news-mentions": [
		50356,
		9,
		15104,
		68039,
		63028,
		33948,
		84114,
		71352,
		55188,
		50356
	],
	"./press/news-mentions/news-mentions.js": [
		50356,
		9,
		15104,
		68039,
		63028,
		33948,
		84114,
		71352,
		55188,
		50356
	],
	"./press/page-context": [
		84114,
		9,
		68039,
		84114
	],
	"./press/page-context.js": [
		84114,
		9,
		68039,
		84114
	],
	"./press/press": [
		63312,
		9,
		15104,
		87850,
		34670,
		68039,
		63028,
		20115,
		50566,
		33948,
		96038,
		3115,
		84114,
		13831,
		80550,
		6771,
		97521,
		6404,
		71352,
		55188,
		75547,
		47943,
		12638,
		28230,
		77897,
		75045,
		76981,
		2130,
		21367,
		62090,
		89392,
		63312
	],
	"./press/press-releases/press-releases": [
		62090,
		9,
		15104,
		68039,
		63028,
		33948,
		84114,
		71352,
		55188,
		76981,
		62090
	],
	"./press/press-releases/press-releases.js": [
		62090,
		9,
		15104,
		68039,
		63028,
		33948,
		84114,
		71352,
		55188,
		76981,
		62090
	],
	"./press/press-releases/press-releases.scss": [
		76981,
		9,
		76981
	],
	"./press/press.js": [
		63312,
		9,
		15104,
		87850,
		34670,
		68039,
		63028,
		20115,
		50566,
		33948,
		96038,
		3115,
		84114,
		13831,
		80550,
		6771,
		97521,
		6404,
		71352,
		55188,
		75547,
		47943,
		12638,
		28230,
		77897,
		75045,
		76981,
		2130,
		21367,
		62090,
		89392,
		63312
	],
	"./press/press.scss": [
		21367,
		9,
		21367
	],
	"./press/testimonials/testimonials": [
		45487,
		9,
		15104,
		68039,
		50566,
		3115,
		84114,
		13831,
		28230,
		80401
	],
	"./press/testimonials/testimonials.js": [
		45487,
		9,
		15104,
		68039,
		50566,
		3115,
		84114,
		13831,
		28230,
		80401
	],
	"./press/testimonials/testimonials.scss": [
		28230,
		9,
		28230
	],
	"./renewal-form/renewal-form": [
		13854,
		9,
		15104,
		63028,
		80370,
		20952,
		4204,
		74730,
		91396,
		13854
	],
	"./renewal-form/renewal-form.js": [
		13854,
		9,
		15104,
		63028,
		80370,
		20952,
		4204,
		74730,
		91396,
		13854
	],
	"./renewal-form/renewal-form.scss": [
		91396,
		9,
		91396
	],
	"./research/components/contact-us": [
		8905,
		9,
		68612,
		24931,
		69697,
		68490,
		35534,
		21112,
		8905
	],
	"./research/components/contact-us.js": [
		8905,
		9,
		68612,
		24931,
		69697,
		68490,
		35534,
		21112,
		8905
	],
	"./research/components/funders": [
		17504,
		9,
		68612,
		24931,
		69697,
		68490,
		35534,
		21112,
		17504
	],
	"./research/components/funders.js": [
		17504,
		9,
		68612,
		24931,
		69697,
		68490,
		35534,
		21112,
		17504
	],
	"./research/components/header": [
		16861,
		9,
		15104,
		68612,
		24931,
		69697,
		68490,
		35534,
		21112,
		16861
	],
	"./research/components/header.js": [
		16861,
		9,
		15104,
		68612,
		24931,
		69697,
		68490,
		35534,
		21112,
		16861
	],
	"./research/components/members": [
		57553,
		9,
		15104,
		87850,
		68612,
		24931,
		69697,
		68490,
		34670,
		63028,
		50295,
		56803,
		96038,
		22151,
		35534,
		21112,
		86718,
		57553
	],
	"./research/components/members.js": [
		57553,
		9,
		15104,
		87850,
		68612,
		24931,
		69697,
		68490,
		34670,
		63028,
		50295,
		56803,
		96038,
		22151,
		35534,
		21112,
		86718,
		57553
	],
	"./research/components/publications": [
		69818,
		9,
		15104,
		68612,
		24931,
		69697,
		68490,
		56803,
		35534,
		21112,
		69818
	],
	"./research/components/publications.js": [
		69818,
		9,
		15104,
		68612,
		24931,
		69697,
		68490,
		56803,
		35534,
		21112,
		69818
	],
	"./research/components/research-areas": [
		56982,
		9,
		15104,
		87850,
		68612,
		24931,
		69697,
		68490,
		34670,
		63028,
		96038,
		22151,
		35534,
		21112,
		86718,
		56982
	],
	"./research/components/research-areas.js": [
		56982,
		9,
		15104,
		87850,
		68612,
		24931,
		69697,
		68490,
		34670,
		63028,
		96038,
		22151,
		35534,
		21112,
		86718,
		56982
	],
	"./research/components/section": [
		21112,
		9,
		68612,
		24931,
		69697,
		68490,
		35534,
		21112
	],
	"./research/components/section.js": [
		21112,
		9,
		68612,
		24931,
		69697,
		68490,
		35534,
		21112
	],
	"./research/components/tab-accordion-combo": [
		86718,
		9,
		15104,
		87850,
		63028,
		96038,
		22151,
		86718
	],
	"./research/components/tab-accordion-combo.js": [
		86718,
		9,
		15104,
		87850,
		63028,
		96038,
		22151,
		86718
	],
	"./research/research": [
		80666,
		9,
		15104,
		87850,
		80570,
		68612,
		24931,
		69697,
		68490,
		34670,
		68039,
		63028,
		20115,
		50295,
		56803,
		89604,
		49374,
		96038,
		22151,
		35534,
		21112,
		86718,
		57553,
		69818,
		46362,
		56982,
		16861,
		17504,
		8905,
		80666
	],
	"./research/research.js": [
		80666,
		9,
		15104,
		87850,
		80570,
		68612,
		24931,
		69697,
		68490,
		34670,
		68039,
		63028,
		20115,
		50295,
		56803,
		89604,
		49374,
		96038,
		22151,
		35534,
		21112,
		86718,
		57553,
		69818,
		46362,
		56982,
		16861,
		17504,
		8905,
		80666
	],
	"./research/research.scss": [
		46362,
		9,
		46362
	],
	"./research/theme": [
		35534,
		9,
		68612,
		24931,
		69697,
		68490,
		35534
	],
	"./research/theme.js": [
		35534,
		9,
		68612,
		24931,
		69697,
		68490,
		35534
	],
	"./separatemap/map-api": [
		1836,
		9,
		20908,
		1836
	],
	"./separatemap/map-api.js": [
		1836,
		9,
		20908,
		1836
	],
	"./separatemap/map-context": [
		640,
		9,
		20908,
		56803,
		1836,
		75132,
		640
	],
	"./separatemap/map-context.js": [
		640,
		9,
		20908,
		56803,
		1836,
		75132,
		640
	],
	"./separatemap/search-box/filters/filters": [
		81247,
		9,
		63028,
		80370,
		4204,
		98677,
		67953,
		83397,
		81247
	],
	"./separatemap/search-box/filters/filters.js": [
		81247,
		9,
		63028,
		80370,
		4204,
		98677,
		67953,
		83397,
		81247
	],
	"./separatemap/search-box/filters/filters.scss": [
		83397,
		9,
		83397
	],
	"./separatemap/search-box/inputs/inputs": [
		55435,
		9,
		15104,
		84034,
		55435
	],
	"./separatemap/search-box/inputs/inputs.js": [
		55435,
		9,
		15104,
		84034,
		55435
	],
	"./separatemap/search-box/inputs/inputs.scss": [
		84034,
		9,
		84034
	],
	"./separatemap/search-box/result-box/result-box": [
		53111,
		9,
		15104,
		55414,
		53111
	],
	"./separatemap/search-box/result-box/result-box.js": [
		53111,
		9,
		15104,
		55414,
		53111
	],
	"./separatemap/search-box/result-box/result-box.scss": [
		55414,
		9,
		55414
	],
	"./separatemap/search-box/results": [
		54807,
		9,
		75132,
		54807
	],
	"./separatemap/search-box/results.js": [
		54807,
		9,
		75132,
		54807
	],
	"./separatemap/search-box/search-box": [
		6447,
		9,
		15104,
		20908,
		63028,
		56803,
		80370,
		4204,
		98677,
		67953,
		84034,
		1836,
		55414,
		83397,
		75132,
		55435,
		53111,
		69789,
		81247,
		640,
		54807,
		6447
	],
	"./separatemap/search-box/search-box.js": [
		6447,
		9,
		15104,
		20908,
		63028,
		56803,
		80370,
		4204,
		98677,
		67953,
		84034,
		1836,
		55414,
		83397,
		75132,
		55435,
		53111,
		69789,
		81247,
		640,
		54807,
		6447
	],
	"./separatemap/search-box/search-box.scss": [
		69789,
		9,
		69789
	],
	"./separatemap/separatemap": [
		31636,
		9,
		15104,
		20908,
		63028,
		20115,
		56803,
		80370,
		4204,
		98677,
		67953,
		89465,
		84034,
		1836,
		55414,
		83397,
		75132,
		55435,
		53111,
		69789,
		81247,
		640,
		54807,
		85604,
		6447,
		31636
	],
	"./separatemap/separatemap.js": [
		31636,
		9,
		15104,
		20908,
		63028,
		20115,
		56803,
		80370,
		4204,
		98677,
		67953,
		89465,
		84034,
		1836,
		55414,
		83397,
		75132,
		55435,
		53111,
		69789,
		81247,
		640,
		54807,
		85604,
		6447,
		31636
	],
	"./separatemap/separatemap.scss": [
		85604,
		9,
		85604
	],
	"./subjects/new/about-openstax": [
		56631,
		9,
		34670,
		68039,
		84230,
		48442,
		82021,
		56631
	],
	"./subjects/new/about-openstax.js": [
		56631,
		9,
		34670,
		68039,
		84230,
		48442,
		82021,
		56631
	],
	"./subjects/new/about-openstax.scss": [
		82021,
		9,
		82021
	],
	"./subjects/new/context": [
		48442,
		9,
		68039,
		48442
	],
	"./subjects/new/context.d": [
		65353,
		7,
		65353
	],
	"./subjects/new/context.d.ts": [
		65353,
		7,
		65353
	],
	"./subjects/new/context.js": [
		48442,
		9,
		68039,
		48442
	],
	"./subjects/new/hero": [
		86419,
		9,
		34670,
		68039,
		13831,
		48442,
		3320,
		86419
	],
	"./subjects/new/hero.js": [
		86419,
		9,
		34670,
		68039,
		13831,
		48442,
		3320,
		86419
	],
	"./subjects/new/hero.scss": [
		3320,
		9,
		3320
	],
	"./subjects/new/import-subjects-listing": [
		86646,
		9,
		15104,
		68039,
		48442,
		4829,
		7170,
		86646
	],
	"./subjects/new/import-subjects-listing.js": [
		86646,
		9,
		15104,
		68039,
		48442,
		4829,
		7170,
		86646
	],
	"./subjects/new/info-boxes": [
		1610,
		9,
		34670,
		68039,
		48442,
		42152,
		1610
	],
	"./subjects/new/info-boxes.js": [
		1610,
		9,
		34670,
		68039,
		48442,
		42152,
		1610
	],
	"./subjects/new/info-boxes.scss": [
		42152,
		9,
		42152
	],
	"./subjects/new/language-selector-section": [
		88483,
		9,
		15104,
		59313,
		88483
	],
	"./subjects/new/language-selector-section.js": [
		88483,
		9,
		15104,
		59313,
		88483
	],
	"./subjects/new/philanthropic-support": [
		93470,
		9,
		34670,
		68039,
		48442,
		9747,
		93470
	],
	"./subjects/new/philanthropic-support.js": [
		93470,
		9,
		34670,
		68039,
		48442,
		9747,
		93470
	],
	"./subjects/new/philanthropic-support.scss": [
		9747,
		9,
		9747
	],
	"./subjects/new/specific/blog-posts": [
		84039,
		9,
		15104,
		68039,
		20115,
		50566,
		84230,
		3115,
		16916,
		9968,
		56512,
		26930,
		2237,
		28744,
		51839,
		84039
	],
	"./subjects/new/specific/blog-posts.js": [
		84039,
		9,
		15104,
		68039,
		20115,
		50566,
		84230,
		3115,
		16916,
		9968,
		56512,
		26930,
		2237,
		28744,
		51839,
		84039
	],
	"./subjects/new/specific/blog-posts.scss": [
		51839,
		9,
		51839
	],
	"./subjects/new/specific/book-viewer": [
		12545,
		9,
		15104,
		33441,
		25783,
		34670,
		68039,
		63028,
		20115,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		40172,
		24536,
		5719,
		95301,
		28521,
		16916,
		85197,
		53246,
		86952,
		6234,
		82017,
		12545
	],
	"./subjects/new/specific/book-viewer.js": [
		12545,
		9,
		15104,
		33441,
		25783,
		34670,
		68039,
		63028,
		20115,
		50295,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		28365,
		76536,
		81321,
		61958,
		40172,
		24536,
		5719,
		95301,
		28521,
		16916,
		85197,
		53246,
		86952,
		6234,
		82017,
		12545
	],
	"./subjects/new/specific/book-viewer.scss": [
		88003,
		9,
		88003
	],
	"./subjects/new/specific/components/carousel-section": [
		26930,
		9,
		15104,
		50566,
		3115,
		9968,
		26930
	],
	"./subjects/new/specific/components/carousel-section.js": [
		26930,
		9,
		15104,
		50566,
		3115,
		9968,
		26930
	],
	"./subjects/new/specific/components/carousel-section.scss": [
		9968,
		9,
		9968
	],
	"./subjects/new/specific/context": [
		16916,
		9,
		68039,
		20115,
		16916
	],
	"./subjects/new/specific/context.d": [
		30025,
		7,
		30025
	],
	"./subjects/new/specific/context.d.ts": [
		30025,
		7,
		30025
	],
	"./subjects/new/specific/context.js": [
		16916,
		9,
		68039,
		20115,
		16916
	],
	"./subjects/new/specific/find-translation": [
		53573,
		7,
		68039,
		53573
	],
	"./subjects/new/specific/find-translation.tsx": [
		53573,
		7,
		68039,
		53573
	],
	"./subjects/new/specific/learn-more": [
		90693,
		9,
		15104,
		87850,
		34670,
		68039,
		20115,
		96038,
		16916,
		46491,
		90693
	],
	"./subjects/new/specific/learn-more.js": [
		90693,
		9,
		15104,
		87850,
		34670,
		68039,
		20115,
		96038,
		16916,
		46491,
		90693
	],
	"./subjects/new/specific/learn-more.scss": [
		46491,
		9,
		46491
	],
	"./subjects/new/specific/navigator": [
		97579,
		9,
		15104,
		87850,
		68039,
		63028,
		20115,
		50566,
		96038,
		80370,
		16916,
		42822,
		64926,
		97579
	],
	"./subjects/new/specific/navigator-context": [
		64926,
		9,
		50566,
		64926
	],
	"./subjects/new/specific/navigator-context.js": [
		64926,
		9,
		50566,
		64926
	],
	"./subjects/new/specific/navigator.js": [
		97579,
		9,
		15104,
		87850,
		68039,
		63028,
		20115,
		50566,
		96038,
		80370,
		16916,
		42822,
		64926,
		97579
	],
	"./subjects/new/specific/navigator.scss": [
		42822,
		9,
		42822
	],
	"./subjects/new/specific/specific": [
		76415,
		9,
		15104,
		33441,
		25783,
		87850,
		80570,
		34670,
		68039,
		63028,
		20115,
		50295,
		50566,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		84230,
		96038,
		80370,
		28365,
		76536,
		81321,
		61958,
		40172,
		24536,
		5719,
		95301,
		28521,
		76415
	],
	"./subjects/new/specific/specific.js": [
		76415,
		9,
		15104,
		33441,
		25783,
		87850,
		80570,
		34670,
		68039,
		63028,
		20115,
		50295,
		50566,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		84230,
		96038,
		80370,
		28365,
		76536,
		81321,
		61958,
		40172,
		24536,
		5719,
		95301,
		28521,
		76415
	],
	"./subjects/new/specific/specific.scss": [
		63457,
		9,
		63457
	],
	"./subjects/new/specific/subject-intro": [
		65449,
		9,
		15104,
		87850,
		34670,
		68039,
		63028,
		20115,
		50566,
		96038,
		80370,
		16916,
		42822,
		64926,
		97579,
		17266,
		65449
	],
	"./subjects/new/specific/subject-intro.js": [
		65449,
		9,
		15104,
		87850,
		34670,
		68039,
		63028,
		20115,
		50566,
		96038,
		80370,
		16916,
		42822,
		64926,
		97579,
		17266,
		65449
	],
	"./subjects/new/specific/subject-intro.scss": [
		17266,
		9,
		17266
	],
	"./subjects/new/specific/translation-selector": [
		42099,
		7,
		15104,
		59313,
		42099
	],
	"./subjects/new/specific/translation-selector.tsx": [
		42099,
		7,
		15104,
		59313,
		42099
	],
	"./subjects/new/specific/use-english-subject": [
		56512,
		7,
		68039,
		20115,
		16916,
		56512,
		2237,
		28744
	],
	"./subjects/new/specific/use-english-subject.ts": [
		56512,
		7,
		68039,
		20115,
		16916,
		56512,
		2237,
		28744
	],
	"./subjects/new/specific/use-found-subject": [
		2237,
		7,
		2237
	],
	"./subjects/new/specific/use-found-subject.ts": [
		2237,
		7,
		2237
	],
	"./subjects/new/specific/use-translations": [
		28744,
		7,
		68039,
		20115,
		16916,
		28744
	],
	"./subjects/new/specific/use-translations.ts": [
		28744,
		7,
		68039,
		20115,
		16916,
		28744
	],
	"./subjects/new/specific/webinars": [
		91863,
		9,
		15104,
		34670,
		68039,
		20115,
		50566,
		3115,
		16916,
		9968,
		56512,
		26930,
		2237,
		28744,
		36783,
		91863
	],
	"./subjects/new/specific/webinars.js": [
		91863,
		9,
		15104,
		34670,
		68039,
		20115,
		50566,
		3115,
		16916,
		9968,
		56512,
		26930,
		2237,
		28744,
		36783,
		91863
	],
	"./subjects/new/specific/webinars.scss": [
		36783,
		9,
		36783
	],
	"./subjects/new/subjects": [
		90804,
		9,
		15104,
		33441,
		25783,
		87850,
		80570,
		34670,
		68039,
		63028,
		20115,
		50295,
		50566,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		84230,
		96038,
		80370,
		28365,
		76536,
		81321,
		61958,
		40172,
		24536,
		13831,
		5719,
		95301,
		76415,
		78873
	],
	"./subjects/new/subjects-listing": [
		7170,
		7,
		15104,
		68039,
		48442,
		4829,
		7170
	],
	"./subjects/new/subjects-listing.scss": [
		4829,
		9,
		4829
	],
	"./subjects/new/subjects-listing.tsx": [
		7170,
		7,
		15104,
		68039,
		48442,
		4829,
		7170
	],
	"./subjects/new/subjects.js": [
		90804,
		9,
		15104,
		33441,
		25783,
		87850,
		80570,
		34670,
		68039,
		63028,
		20115,
		50295,
		50566,
		56803,
		42673,
		27752,
		37827,
		54873,
		20109,
		84230,
		96038,
		80370,
		28365,
		76536,
		81321,
		61958,
		40172,
		24536,
		13831,
		5719,
		95301,
		76415,
		78873
	],
	"./subjects/new/subjects.scss": [
		23012,
		9,
		23012
	],
	"./subjects/new/tutor-ad": [
		32730,
		9,
		34670,
		68039,
		84230,
		48442,
		65728,
		32730
	],
	"./subjects/new/tutor-ad.js": [
		32730,
		9,
		34670,
		68039,
		84230,
		48442,
		65728,
		32730
	],
	"./subjects/new/tutor-ad.scss": [
		65728,
		9,
		65728
	],
	"./subjects/new/use-categorized-books": [
		72885,
		9,
		68039,
		48442,
		72885
	],
	"./subjects/new/use-categorized-books.js": [
		72885,
		9,
		68039,
		48442,
		72885
	],
	"./subjects/old/book-viewer/book": [
		42989,
		9,
		15104,
		80570,
		86952,
		82017,
		42989
	],
	"./subjects/old/book-viewer/book-viewer": [
		89390,
		9,
		15104,
		80570,
		34670,
		68039,
		86952,
		82017,
		42989,
		5052,
		89390
	],
	"./subjects/old/book-viewer/book-viewer.js": [
		89390,
		9,
		15104,
		80570,
		34670,
		68039,
		86952,
		82017,
		42989,
		5052,
		89390
	],
	"./subjects/old/book-viewer/book.js": [
		42989,
		9,
		15104,
		80570,
		86952,
		82017,
		42989
	],
	"./subjects/old/context": [
		5052,
		9,
		68039,
		5052
	],
	"./subjects/old/context.js": [
		5052,
		9,
		68039,
		5052
	],
	"./subjects/old/subjects": [
		21287,
		9,
		15104,
		80570,
		34670,
		68039,
		20115,
		59313,
		86952,
		82017,
		86870,
		9767,
		42989,
		5052,
		36920,
		89390,
		21287
	],
	"./subjects/old/subjects.js": [
		21287,
		9,
		15104,
		80570,
		34670,
		68039,
		20115,
		59313,
		86952,
		82017,
		86870,
		9767,
		42989,
		5052,
		36920,
		89390,
		21287
	],
	"./subjects/old/subjects.scss": [
		36920,
		9,
		36920
	],
	"./subjects/subjects": [
		94014,
		9,
		94014
	],
	"./subjects/subjects.js": [
		94014,
		9,
		94014
	],
	"./team/people-tab/people-tab": [
		51930,
		9,
		19157,
		51930
	],
	"./team/people-tab/people-tab.js": [
		51930,
		9,
		19157,
		51930
	],
	"./team/people-tab/people-tab.scss": [
		19157,
		9,
		19157
	],
	"./team/team": [
		35093,
		9,
		15104,
		87850,
		68039,
		63028,
		20115,
		50566,
		89604,
		49374,
		96038,
		22151,
		13831,
		35233,
		19157,
		13679,
		51930,
		35093
	],
	"./team/team.js": [
		35093,
		9,
		15104,
		87850,
		68039,
		63028,
		20115,
		50566,
		89604,
		49374,
		96038,
		22151,
		13831,
		35233,
		19157,
		13679,
		51930,
		35093
	],
	"./team/team.scss": [
		13679,
		9,
		13679
	],
	"./webinars/explore-page/explore-page": [
		47042,
		7,
		15104,
		67913,
		20115,
		33948,
		30604,
		61420,
		73721,
		1401,
		44016,
		8011,
		85453,
		54088,
		31344,
		90760,
		47042
	],
	"./webinars/explore-page/explore-page.scss": [
		31344,
		9,
		31344
	],
	"./webinars/explore-page/explore-page.tsx": [
		47042,
		7,
		15104,
		67913,
		20115,
		33948,
		30604,
		61420,
		73721,
		1401,
		44016,
		8011,
		85453,
		54088,
		31344,
		90760,
		47042
	],
	"./webinars/explore-page/heading-and-search-bar": [
		90760,
		7,
		15104,
		1401,
		44016,
		90760
	],
	"./webinars/explore-page/heading-and-search-bar.tsx": [
		90760,
		7,
		15104,
		1401,
		44016,
		90760
	],
	"./webinars/import-explore-page": [
		14074,
		9,
		15104,
		67913,
		20115,
		33948,
		30604,
		61420,
		73721,
		1401,
		44016,
		8011,
		85453,
		54088,
		31344,
		90760,
		47042,
		14074
	],
	"./webinars/import-explore-page.js": [
		14074,
		9,
		15104,
		67913,
		20115,
		33948,
		30604,
		61420,
		73721,
		1401,
		44016,
		8011,
		85453,
		54088,
		31344,
		90760,
		47042,
		14074
	],
	"./webinars/import-main-page": [
		41519,
		9,
		15104,
		67913,
		20115,
		33948,
		30604,
		61420,
		73721,
		1401,
		44016,
		8011,
		85453,
		60482,
		98856,
		11901,
		40100,
		94951,
		10409,
		94168,
		41519
	],
	"./webinars/import-main-page.js": [
		41519,
		9,
		15104,
		67913,
		20115,
		33948,
		30604,
		61420,
		73721,
		1401,
		44016,
		8011,
		85453,
		60482,
		98856,
		11901,
		40100,
		94951,
		10409,
		94168,
		41519
	],
	"./webinars/import-search-page": [
		7637,
		9,
		15104,
		67913,
		33948,
		30604,
		61420,
		73721,
		1401,
		44016,
		8011,
		85453,
		60482,
		11901,
		66097,
		77149,
		73431,
		23647,
		7637
	],
	"./webinars/import-search-page.js": [
		7637,
		9,
		15104,
		67913,
		33948,
		30604,
		61420,
		73721,
		1401,
		44016,
		8011,
		85453,
		60482,
		11901,
		66097,
		77149,
		73431,
		23647,
		7637
	],
	"./webinars/main-page/latest-webinars": [
		77149,
		7,
		15104,
		33948,
		30604,
		61420,
		73721,
		1401,
		60482,
		11901,
		77149
	],
	"./webinars/main-page/latest-webinars.tsx": [
		77149,
		7,
		15104,
		33948,
		30604,
		61420,
		73721,
		1401,
		60482,
		11901,
		77149
	],
	"./webinars/main-page/main-page": [
		94168,
		7,
		15104,
		67913,
		20115,
		33948,
		30604,
		61420,
		73721,
		1401,
		44016,
		8011,
		85453,
		60482,
		98856,
		11901,
		40100,
		94951,
		10409,
		94168
	],
	"./webinars/main-page/main-page.tsx": [
		94168,
		7,
		15104,
		67913,
		20115,
		33948,
		30604,
		61420,
		73721,
		1401,
		44016,
		8011,
		85453,
		60482,
		98856,
		11901,
		40100,
		94951,
		10409,
		94168
	],
	"./webinars/main-page/past-webinars": [
		10409,
		7,
		15104,
		67913,
		33948,
		30604,
		61420,
		73721,
		1401,
		8011,
		98856,
		40100,
		10409
	],
	"./webinars/main-page/past-webinars.tsx": [
		10409,
		7,
		15104,
		67913,
		33948,
		30604,
		61420,
		73721,
		1401,
		8011,
		98856,
		40100,
		10409
	],
	"./webinars/main-page/upcoming-webinars": [
		94951,
		7,
		15104,
		33948,
		30604,
		61420,
		73721,
		1401,
		85453,
		60482,
		11901,
		94951
	],
	"./webinars/main-page/upcoming-webinars.tsx": [
		94951,
		7,
		15104,
		33948,
		30604,
		61420,
		73721,
		1401,
		85453,
		60482,
		11901,
		94951
	],
	"./webinars/search-page/no-results": [
		73431,
		7,
		15104,
		33948,
		30604,
		61420,
		73721,
		1401,
		60482,
		11901,
		66097,
		77149,
		73431
	],
	"./webinars/search-page/no-results.scss": [
		66097,
		9,
		66097
	],
	"./webinars/search-page/no-results.tsx": [
		73431,
		7,
		15104,
		33948,
		30604,
		61420,
		73721,
		1401,
		60482,
		11901,
		66097,
		77149,
		73431
	],
	"./webinars/search-page/search-page": [
		23647,
		7,
		15104,
		67913,
		33948,
		30604,
		61420,
		73721,
		1401,
		44016,
		8011,
		85453,
		60482,
		11901,
		66097,
		77149,
		73431,
		23647
	],
	"./webinars/search-page/search-page.tsx": [
		23647,
		7,
		15104,
		67913,
		33948,
		30604,
		61420,
		73721,
		1401,
		44016,
		8011,
		85453,
		60482,
		11901,
		66097,
		77149,
		73431,
		23647
	],
	"./webinars/types": [
		28977,
		9,
		28977
	],
	"./webinars/types.ts": [
		28977,
		9,
		28977
	],
	"./webinars/view-webinars-page/latest-page": [
		59463,
		9,
		15104,
		67913,
		33948,
		30604,
		61420,
		73721,
		1401,
		44016,
		8011,
		85453,
		98856,
		40100,
		92353,
		59463
	],
	"./webinars/view-webinars-page/latest-page.js": [
		59463,
		9,
		15104,
		67913,
		33948,
		30604,
		61420,
		73721,
		1401,
		44016,
		8011,
		85453,
		98856,
		40100,
		92353,
		59463
	],
	"./webinars/view-webinars-page/upcoming-page": [
		23061,
		9,
		15104,
		67913,
		33948,
		30604,
		61420,
		73721,
		1401,
		44016,
		8011,
		85453,
		98856,
		40100,
		92353,
		23061
	],
	"./webinars/view-webinars-page/upcoming-page.js": [
		23061,
		9,
		15104,
		67913,
		33948,
		30604,
		61420,
		73721,
		1401,
		44016,
		8011,
		85453,
		98856,
		40100,
		92353,
		23061
	],
	"./webinars/view-webinars-page/view-webinars-page": [
		92353,
		7,
		15104,
		67913,
		33948,
		30604,
		61420,
		73721,
		1401,
		44016,
		8011,
		85453,
		98856,
		40100,
		92353
	],
	"./webinars/view-webinars-page/view-webinars-page.tsx": [
		92353,
		7,
		15104,
		67913,
		33948,
		30604,
		61420,
		73721,
		1401,
		44016,
		8011,
		85453,
		98856,
		40100,
		92353
	],
	"./webinars/webinar-cards/paginated-webinar-grid": [
		40100,
		7,
		15104,
		67913,
		33948,
		30604,
		61420,
		73721,
		8011,
		98856,
		40100
	],
	"./webinars/webinar-cards/paginated-webinar-grid.scss": [
		98856,
		9,
		98856
	],
	"./webinars/webinar-cards/paginated-webinar-grid.tsx": [
		40100,
		7,
		15104,
		67913,
		33948,
		30604,
		61420,
		73721,
		8011,
		98856,
		40100
	],
	"./webinars/webinar-cards/webinar-grid": [
		73721,
		7,
		15104,
		33948,
		30604,
		61420,
		73721
	],
	"./webinars/webinar-cards/webinar-grid-section": [
		11901,
		7,
		15104,
		33948,
		30604,
		61420,
		73721,
		60482,
		11901
	],
	"./webinars/webinar-cards/webinar-grid-section.scss": [
		60482,
		9,
		60482
	],
	"./webinars/webinar-cards/webinar-grid-section.tsx": [
		11901,
		7,
		15104,
		33948,
		30604,
		61420,
		73721,
		60482,
		11901
	],
	"./webinars/webinar-cards/webinar-grid.scss": [
		61420,
		9,
		61420
	],
	"./webinars/webinar-cards/webinar-grid.tsx": [
		73721,
		7,
		15104,
		33948,
		30604,
		61420,
		73721
	],
	"./webinars/webinar-context": [
		1401,
		7,
		1401
	],
	"./webinars/webinar-context.tsx": [
		1401,
		7,
		1401
	],
	"./webinars/webinars": [
		97839,
		7,
		15104,
		67913,
		20115,
		33948,
		30604,
		61420,
		73721,
		1401,
		44016,
		8011,
		85453,
		60482,
		54088,
		98856,
		11901,
		40100,
		66097,
		77149,
		31344,
		92353,
		90760,
		94951,
		73431,
		10409,
		94168,
		47042,
		23647,
		54351,
		59463,
		97839
	],
	"./webinars/webinars.scss": [
		54351,
		9,
		54351
	],
	"./webinars/webinars.tsx": [
		97839,
		7,
		15104,
		67913,
		20115,
		33948,
		30604,
		61420,
		73721,
		1401,
		44016,
		8011,
		85453,
		60482,
		54088,
		98856,
		11901,
		40100,
		66097,
		77149,
		31344,
		92353,
		90760,
		94951,
		73431,
		10409,
		94168,
		47042,
		23647,
		54351,
		59463,
		97839
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 42810;
module.exports = webpackAsyncContext;